var _style, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSomethingWrong(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-bug-fixing",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-bug-fixing:not(.animated) .animable {opacity: 0;}svg#freepik_stories-bug-fixing.animated\r\n        #freepik--Floor--inject-21 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideDown;animation-delay:\r\n        0s;}svg#freepik_stories-bug-fixing.animated #freepik--Shadows--inject-21 {animation: 1s 1 forwards\r\n        cubic-bezier(.36,-0.01,.5,1.38) fadeIn;animation-delay: 0s;}svg#freepik_stories-bug-fixing.animated\r\n        #freepik--Plants--inject-21 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideUp;animation-delay:\r\n        0s;}svg#freepik_stories-bug-fixing.animated #freepik--Screen--inject-21 {animation: 1s 1 forwards\r\n        cubic-bezier(.36,-0.01,.5,1.38) slideUp;animation-delay: 0s;}svg#freepik_stories-bug-fixing.animated\r\n        #freepik--Cones--inject-21 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideUp;animation-delay:\r\n        0s;}svg#freepik_stories-bug-fixing.animated #freepik--character-2--inject-21 {animation: 1s 1 forwards\r\n        cubic-bezier(.36,-0.01,.5,1.38) slideLeft;animation-delay: 0s;}svg#freepik_stories-bug-fixing.animated\r\n        #freepik--character-1--inject-21 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38)\r\n        zoomIn;animation-delay: 0s;}svg#freepik_stories-bug-fixing.animated #freepik--Gears--inject-21 {animation: 1s 1\r\n        forwards cubic-bezier(.36,-0.01,.5,1.38) slideDown;animation-delay: 0s;} @keyframes slideDown { 0% { opacity: 0;\r\n        transform: translateY(-30px); } 100% { opacity: 1; transform: translateY(0); } } @keyframes fadeIn { 0% {\r\n        opacity: 0; } 100% { opacity: 1; } } @keyframes slideUp { 0% { opacity: 0; transform: translateY(30px); } 100% {\r\n        opacity: 1; transform: inherit; } } @keyframes slideLeft { 0% { opacity: 0; transform: translateX(-30px); } 100%\r\n        { opacity: 1; transform: translateX(0); } } @keyframes zoomIn { 0% { opacity: 0; transform: scale(0.5); } 100% {\r\n        opacity: 1; transform: scale(1); } }\r\n    ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-21",
    className: "animable",
    style: {
      transformOrigin: "250px 344.342px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M414.43,250.84c91.41,51.64,91.89,135.35,1.08,187s-238.53,51.64-329.94,0-91.89-135.36-1.08-187S323,199.2,414.43,250.84Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "250px 344.342px"
    },
    id: "eldjtd2xv8eyp",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-21",
    className: "animable",
    style: {
      transformOrigin: "253.238px 330.595px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.31,370c1.58.9,1.58,2.37,0,3.27L160,389.16a6.19,6.19,0,0,1-5.65,0l-27.5-15.88c-1.57-.9-1.58-2.37,0-3.27l27.32-15.88a6.27,6.27,0,0,1,5.66,0Z",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "157.082px 371.649px"
    },
    id: "elkjfcjeev6f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.75,338.9c1.57.91,1.57,2.38,0,3.28l-27.33,15.88a6.25,6.25,0,0,1-5.65,0l-27.5-15.88c-1.57-.9-1.57-2.37,0-3.27L207.6,323a6.19,6.19,0,0,1,5.65,0Z",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "210.51px 340.526px"
    },
    id: "el8obd2znwwnb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.64,365.81l13.79,8.08a5.51,5.51,0,0,0,5.54,0L328.79,229.35a2.2,2.2,0,0,0,0-3.82L315,217.44a5.54,5.54,0,0,0-5.54,0L58.65,362A2.21,2.21,0,0,0,58.64,365.81Z",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "193.727px 295.667px"
    },
    id: "el4xryyz45s79",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.32,395.58c19.38,11.19,19.49,29.33.23,40.52s-50.57,11.19-70,0-19.49-29.33-.23-40.52S293.94,384.39,313.32,395.58Z",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "278.426px 415.84px"
    },
    id: "elrn0qtj9cik9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.7,281.63c-18.88-10.9-49.39-10.9-68.15,0-11.87,6.9-16.17,16.51-13,25.4-13.51-1.35-27.89,1-38.28,7-17,9.87-16.9,25.87.2,35.75s44.73,9.87,61.72,0c10-5.82,14.07-13.75,12.25-21.31,15.81,2.22,33.15-.24,45.44-7.39C453.68,310.2,453.58,292.53,434.7,281.63Z",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "375.751px 315.321px"
    },
    id: "elj8cib6y5h1",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-21",
    className: "animable",
    style: {
      transformOrigin: "247.719px 308.919px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.49,307c-2.07-2-4.45-4.21-4.57-7.1a6.32,6.32,0,0,1,4.2-5.87,9.52,9.52,0,0,1,7.47.63,20.38,20.38,0,0,1,6,4.83,48,48,0,0,1,11,42,3.5,3.5,0,0,1-1.43,2.5c-1.4.73-3-.58-3.92-1.85a28.81,28.81,0,0,1-4.56-9.2c-.81-2.79-.41-5.88-1.44-8.52C57.64,318,52.41,311.8,47.49,307Z",
    style: {
      fill: "current",
      transformOrigin: "57.7981px 318.872px"
    },
    id: "el2wfkirrtm09",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.91,340.25h0a.56.56,0,0,1-.55-.57,54.54,54.54,0,0,0-20.09-42.24.56.56,0,0,1-.09-.78.57.57,0,0,1,.79-.09,55.7,55.7,0,0,1,20.5,43.13A.56.56,0,0,1,68.91,340.25Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "58.7659px 318.35px"
    },
    id: "el3fh26s8g1j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9,362.31c-3.52,1.1-7.92.33-9.93-2.77-2.36-3.64-.82-9.2-4-12.15-1.78-1.65-4.41-1.83-6.79-2.34s-5-1.84-5.33-4.24c-.45-3.19,3.48-5.8,3-9s-4.83-4.14-6.08-7.05c-1.14-2.65.94-5.84,3.66-6.8s5.75-.27,8.46.76,5.32,2.38,8.19,2.75,6.43-.17,8.61,1.9c2.91,2.77,1.19,8,3.43,11.31,1.5,2.23,4.36,3,6.54,4.59A10.57,10.57,0,0,1,75.9,348c-.1,3.64-2,6.26-4.81,8.34C68.15,358.5,65.52,361.17,61.9,362.31Z",
    style: {
      fill: "current",
      transformOrigin: "54.1772px 340.143px"
    },
    id: "elhspjmrzarwm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eltlnxnizf8xc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.9,362.31c-3.52,1.1-7.92.33-9.93-2.77-2.36-3.64-.82-9.2-4-12.15-1.78-1.65-4.41-1.83-6.79-2.34s-5-1.84-5.33-4.24c-.45-3.19,3.48-5.8,3-9s-4.83-4.14-6.08-7.05c-1.14-2.65.94-5.84,3.66-6.8s5.75-.27,8.46.76,5.32,2.38,8.19,2.75,6.43-.17,8.61,1.9c2.91,2.77,1.19,8,3.43,11.31,1.5,2.23,4.36,3,6.54,4.59A10.57,10.57,0,0,1,75.9,348c-.1,3.64-2,6.26-4.81,8.34C68.15,358.5,65.52,361.17,61.9,362.31Z",
    style: {
      opacity: 0.3,
      transformOrigin: "54.1772px 340.143px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.51,337.4l0-.06c-.52-.76-1.06-1.51-1.63-2.24a40.3,40.3,0,0,0-20.08-13.58.55.55,0,0,0-.69.37.55.55,0,0,0,.38.69A39.28,39.28,0,0,1,58,335.79l.44.61c-6.27-2.36-12.7-1.1-16.14,1.63a.56.56,0,0,0-.09.78.54.54,0,0,0,.43.21.57.57,0,0,0,.35-.12c3.41-2.7,10.41-3.86,16.73-.74a39.29,39.29,0,0,1,6.58,19.68.55.55,0,0,0,.55.53h0a.56.56,0,0,0,.53-.58A40.37,40.37,0,0,0,60.51,337.4Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "52.7333px 339.933px"
    },
    id: "el0liwe85yuc1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.48,265.33c1.58-1.54,3.39-3.22,3.48-5.42a4.83,4.83,0,0,0-3.2-4.49,7.35,7.35,0,0,0-5.71.48,15.56,15.56,0,0,0-4.54,3.7,36.65,36.65,0,0,0-8.39,32.08,2.69,2.69,0,0,0,1.1,1.91c1.07.55,2.27-.45,3-1.41a22.12,22.12,0,0,0,3.48-7c.62-2.13.32-4.49,1.11-6.51C443.73,273.7,447.72,269,451.48,265.33Z",
    style: {
      fill: "current",
      transformOrigin: "443.623px 274.401px"
    },
    id: "el9h4gchvvmss",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.12,290.7h0a.42.42,0,0,0,.42-.43A41.63,41.63,0,0,1,450.88,258a.42.42,0,0,0,.06-.59.43.43,0,0,0-.59-.07,42.48,42.48,0,0,0-15.66,32.93A.43.43,0,0,0,435.12,290.7Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "442.862px 273.977px"
    },
    id: "el43cfndp8v7g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.47,307.55c2.69.84,6,.25,7.58-2.12,1.81-2.77.63-7,3.06-9.27,1.36-1.26,3.37-1.4,5.18-1.79s3.82-1.41,4.07-3.24c.34-2.44-2.66-4.43-2.26-6.85s3.69-3.17,4.64-5.39c.88-2-.71-4.46-2.79-5.19s-4.39-.21-6.46.58a28.92,28.92,0,0,1-6.25,2.1c-2.28.3-4.92-.13-6.58,1.45-2.22,2.11-.91,6.09-2.62,8.63-1.14,1.71-3.33,2.31-5,3.51a7.81,7.81,0,0,0,.4,13C435.7,304.64,437.71,306.68,440.47,307.55Z",
    style: {
      fill: "current",
      transformOrigin: "446.37px 290.631px"
    },
    id: "el0kw0szrw4hr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el03xf5ultn0ns"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M440.47,307.55c2.69.84,6,.25,7.58-2.12,1.81-2.77.63-7,3.06-9.27,1.36-1.26,3.37-1.4,5.18-1.79s3.82-1.41,4.07-3.24c.34-2.44-2.66-4.43-2.26-6.85s3.69-3.17,4.64-5.39c.88-2-.71-4.46-2.79-5.19s-4.39-.21-6.46.58a28.92,28.92,0,0,1-6.25,2.1c-2.28.3-4.92-.13-6.58,1.45-2.22,2.11-.91,6.09-2.62,8.63-1.14,1.71-3.33,2.31-5,3.51a7.81,7.81,0,0,0,.4,13C435.7,304.64,437.71,306.68,440.47,307.55Z",
    style: {
      opacity: 0.3,
      transformOrigin: "446.37px 290.631px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M441.53,288.53l0,0c.4-.58.81-1.16,1.25-1.71a30.74,30.74,0,0,1,15.33-10.37.42.42,0,0,1,.53.28.43.43,0,0,1-.29.53,30,30,0,0,0-14.91,10.08c-.12.16-.22.32-.34.47,4.79-1.8,9.7-.84,12.33,1.25a.41.41,0,0,1,.07.59.39.39,0,0,1-.33.16.36.36,0,0,1-.27-.09c-2.6-2.06-7.94-2.95-12.77-.57a29.88,29.88,0,0,0-5,15,.43.43,0,0,1-.42.4h0a.43.43,0,0,1-.4-.45A30.85,30.85,0,0,1,441.53,288.53Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "447.483px 290.49px"
    },
    id: "elra9gk1k90h",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-21",
    className: "animable",
    style: {
      transformOrigin: "195.435px 203.153px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.4,54.38,73.16,200,65,195.26l.47,166.3a2.87,2.87,0,0,0,1.2,2.64L74.83,369a2.88,2.88,0,0,1-.27-.22c.75.64,1.9.68,3.2-.07l244-140.87a9,9,0,0,0,4.11-7.11Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "195.435px 211.823px"
    },
    id: "ely1vtci3j2aq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.29,49.64a3,3,0,0,0-.06-.62.67.67,0,0,0-.06-.17,2,2,0,0,0-.11-.35,1.4,1.4,0,0,0-.1-.16,2,2,0,0,0-.16-.24h0a1.17,1.17,0,0,0-.35-.28h0a1.26,1.26,0,0,0-.42-.16h0a1.47,1.47,0,0,0-.47,0h0a2.82,2.82,0,0,0-1.11.38,5.42,5.42,0,0,0-1.59,1.48l0,0-.09.14c-.06.08-.1.15-.15.23s-.11.15-.15.23h0c-.05.08-.08.16-.12.23l-.14.27-.08.16v0a.49.49,0,0,1,0,.11c0,.11-.08.23-.12.34l-.09.22a0,0,0,0,1,0,0,5,5,0,0,0-.22,1.4c0,1.81,1.29,2.54,2.86,1.63A6.26,6.26,0,0,0,321.29,49.64Z",
    style: {
      fill: "current",
      transformOrigin: "318.495px 51.2564px"
    },
    id: "elu6x0yhsj4xn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.6,54a1.92,1.92,0,0,0-.43-.92,1.17,1.17,0,0,0-.35-.28h0a1.26,1.26,0,0,0-.42-.16h0a1.74,1.74,0,0,0-.46,0h0a2,2,0,0,0-.51.11h0a2.72,2.72,0,0,0-.58.27,6.25,6.25,0,0,0-2.84,4.9,2.93,2.93,0,0,0,.23,1.15,1.45,1.45,0,0,0,1.52.87,2.94,2.94,0,0,0,.54-.12,2.66,2.66,0,0,0,.57-.27,4.21,4.21,0,0,0,.58-.39,6.17,6.17,0,0,0,.53-.5,6.7,6.7,0,0,0,1.68-3.33,5.6,5.6,0,0,0,.05-.69A3.06,3.06,0,0,0,312.6,54Z",
    style: {
      fill: "current",
      transformOrigin: "309.86px 56.2884px"
    },
    id: "elxkz8cu2sbls",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.91,58.8a1.83,1.83,0,0,0-.11-.33h0c0-.06-.07-.11-.1-.16a2,2,0,0,0-.16-.24.88.88,0,0,0-.15-.12,1.06,1.06,0,0,0-.2-.17h0a1.5,1.5,0,0,0-.42-.15h0a2.43,2.43,0,0,0-.47,0h0a2.6,2.6,0,0,0-.51.11l-.05,0a2.42,2.42,0,0,0-.52.24c-.15.08-.29.19-.44.29l-.1.08,0,0a.74.74,0,0,1-.13.12l0,0-.24.23a.23.23,0,0,0-.07.07.47.47,0,0,0-.1.1l0,.05c-.07.07-.13.15-.19.22l-.17.21,0,0s0,0,0,0a6.09,6.09,0,0,0-1.24,3.44c0,1.8,1.28,2.53,2.85,1.63a4.93,4.93,0,0,0,1.11-.9,6.41,6.41,0,0,0,.9-1.22,6.91,6.91,0,0,0,.61-1.4,5,5,0,0,0,.22-1.4A4,4,0,0,0,304,59Z",
    style: {
      fill: "current",
      transformOrigin: "301.385px 61.212px"
    },
    id: "elis74d68l7ao",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.4,44.62A2.86,2.86,0,0,0,324.19,42h0L316,37.22h0l-.2-.11-.22-.07-.15,0h0l-.05,0-.25,0h-.58l-.37.08-.15.06-.15,0-.18.06a4.48,4.48,0,0,0-.58.29l-244,140.87a6.32,6.32,0,0,0-.77.54l-.24.21-.36.31-.16.17-.14.15-.15.16c-.11.13-.23.27-.33.41l-.12.15a.35.35,0,0,0,0,.08,1.34,1.34,0,0,0-.11.14l-.24.36-.21.35,0,0,0,0c-.05.09-.1.19-.16.28s-.12.24-.17.36a3.13,3.13,0,0,0-.15.32v0h0l-.15.37c0,.13-.1.26-.14.39l-.06.2a.31.31,0,0,0,0,.08c0,.05,0,.1,0,.14s-.08.32-.11.48a2.74,2.74,0,0,0-.05.28l0,.15s0,.1,0,.14a5.51,5.51,0,0,0,0,.81l0,10,8.19,4.76L325.43,54.65ZM73.26,189.16h0a7,7,0,0,1,.17-.73A7,7,0,0,0,73.26,189.16ZM303.81,61a6.91,6.91,0,0,1-.61,1.4,6.41,6.41,0,0,1-.9,1.22,4.93,4.93,0,0,1-1.11.9c-1.57.9-2.85.17-2.85-1.63a6.09,6.09,0,0,1,1.24-3.44s0,0,0,0l0,0,.17-.21c.06-.07.12-.15.19-.22l0-.05a.47.47,0,0,1,.1-.1.23.23,0,0,1,.07-.07l.24-.23,0,0a.74.74,0,0,0,.13-.12l0,0,.1-.08c.14-.1.29-.21.43-.29h0a2.66,2.66,0,0,1,.52-.24l.05,0a2.6,2.6,0,0,1,.51-.11h0a2.43,2.43,0,0,1,.47,0h0a1.5,1.5,0,0,1,.42.15h0c.07,0,.13.11.2.16l.15.13a1.4,1.4,0,0,1,.15.24.91.91,0,0,1,.11.16h0a2.55,2.55,0,0,1,.11.33c0,.06,0,.12.06.19a4,4,0,0,1,.06.62A5,5,0,0,1,303.81,61Zm8.8-5.69a6.7,6.7,0,0,1-1.68,3.33,6.17,6.17,0,0,1-.53.5,4.21,4.21,0,0,1-.58.39,2.66,2.66,0,0,1-.57.27,2.94,2.94,0,0,1-.54.12,1.45,1.45,0,0,1-1.52-.87,2.93,2.93,0,0,1-.23-1.15A6.25,6.25,0,0,1,309.8,53a2.72,2.72,0,0,1,.58-.27h0a2,2,0,0,1,.51-.11h0a1.74,1.74,0,0,1,.46,0h0a1.26,1.26,0,0,1,.42.16h0a1.17,1.17,0,0,1,.35.28,1.92,1.92,0,0,1,.43.92,3.06,3.06,0,0,1,.06.63A5.6,5.6,0,0,1,312.61,55.32Zm5.84-.76c-1.57.91-2.85.18-2.86-1.63a5,5,0,0,1,.22-1.4,0,0,0,0,0,0,0l.09-.22c0-.11.07-.23.12-.34a.49.49,0,0,0,0-.11v0l.08-.16.14-.27c0-.07.07-.15.12-.23h0c0-.08.1-.15.15-.23s.09-.15.15-.23l.09-.14,0,0A5.42,5.42,0,0,1,318.43,48a2.82,2.82,0,0,1,1.11-.38h0a1.47,1.47,0,0,1,.47,0h0a1.26,1.26,0,0,1,.42.16,1.17,1.17,0,0,1,.35.28h0a2,2,0,0,1,.16.24c0,.06.07.1.1.16a2.24,2.24,0,0,1,.11.34,1,1,0,0,1,.06.18,3,3,0,0,1,.06.62A6.26,6.26,0,0,1,318.45,54.56Zm3.71-12.69h0a1.46,1.46,0,0,1,.2,0A1.6,1.6,0,0,0,322.16,41.87Zm.74-.16h0a2,2,0,0,1,.25,0Zm.69,0h0l.24.09A2.5,2.5,0,0,0,323.59,41.75Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "195.358px 118.615px"
    },
    id: "el7xudagoy3dn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.36,368.82a2.22,2.22,0,0,1-.22-.34c0-.08-.11-.15-.16-.24a3.82,3.82,0,0,1-.15-.48c0-.1-.07-.17-.09-.27a5.11,5.11,0,0,1-.08-.9l-.48-166.31L65,195.52l.48,166.31a2.87,2.87,0,0,0,1.2,2.64l8.19,4.76a2,2,0,0,1-.28-.23C74.51,368.94,74.43,368.89,74.36,368.82Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "69.935px 282.375px"
    },
    id: "elgo2m3obv1pa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.16,190.26a5.13,5.13,0,0,1,.07-.95l0-.15h0a7,7,0,0,1,.17-.73,1,1,0,0,1,0-.17.31.31,0,0,1,0-.08,8.72,8.72,0,0,1,.36-1v0c.09-.22.21-.43.32-.64s.1-.22.16-.32h0l0,0h0a8.92,8.92,0,0,1,.58-.88h0l0-.08a8.48,8.48,0,0,1,.6-.72l.14-.15h0c.11-.12.23-.22.35-.33s.11-.11.17-.15l.24-.21a6.32,6.32,0,0,1,.77-.54l-8.19-4.76a6.32,6.32,0,0,0-.77.54l-.24.21-.36.31-.16.17-.14.15-.15.16c-.11.13-.23.27-.33.41l-.12.15a.35.35,0,0,0,0,.08,1.34,1.34,0,0,0-.11.14l-.24.36-.21.35,0,0,0,0c-.05.09-.1.19-.16.28s-.12.24-.17.36a3.13,3.13,0,0,0-.15.32v0h0l-.15.37c0,.13-.1.26-.14.39l-.06.2a.31.31,0,0,0,0,.08c0,.05,0,.1,0,.14s-.08.32-.11.48a2.74,2.74,0,0,0-.05.28l0,.15s0,.1,0,.14a5.51,5.51,0,0,0,0,.81l0,10,8.19,4.76Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "71.0775px 189.295px"
    },
    id: "el2404cirqziz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.26,42.27a4.37,4.37,0,0,1,.9-.4h0a1.46,1.46,0,0,1,.2,0c.18,0,.36-.09.53-.11h0a2,2,0,0,1,.25,0,3.15,3.15,0,0,1,.44,0h0l.24.09a1.7,1.7,0,0,1,.35.14h0L316,37.22h0l-.2-.11-.22-.07-.15,0h0l-.05,0-.25,0h-.58l-.37.08-.15.06-.15,0-.18.06a4.48,4.48,0,0,0-.58.29l-244,140.87,8.19,4.76Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "196.645px 110.1px"
    },
    id: "elizgvn7j8uk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271,227.47c.35-.2.63,0,.63.36a1.38,1.38,0,0,1-.62,1.07c-.35.2-.63,0-.63-.35A1.36,1.36,0,0,1,271,227.47Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "271.005px 228.185px"
    },
    id: "elshs69mtw5o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271,225.31c.34-.21.62,0,.62.36a1.39,1.39,0,0,1-.62,1.08c-.35.2-.62,0-.63-.36A1.37,1.37,0,0,1,271,225.31Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "270.995px 226.028px"
    },
    id: "el1w6apcawcjaj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271,220.09c.35-.2.62-.05.63.35a1.37,1.37,0,0,1-.63,1.08c-.34.2-.62,0-.62-.36A1.34,1.34,0,0,1,271,220.09Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "271.005px 220.801px"
    },
    id: "el9ntfx1iljn4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271,217.92c.35-.2.63,0,.63.37a1.36,1.36,0,0,1-.62,1.07c-.35.2-.63,0-.63-.35A1.4,1.4,0,0,1,271,217.92Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "271.005px 218.64px"
    },
    id: "el986lro10uxo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.94,205.32c.35-.2.62,0,.62.36a1.33,1.33,0,0,1-.62,1.07c-.35.21-.62,0-.62-.35A1.36,1.36,0,0,1,270.94,205.32Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "270.94px 206.037px"
    },
    id: "elg9yzf9t366p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.93,203.16c.35-.2.63,0,.63.36a1.37,1.37,0,0,1-.62,1.08c-.35.2-.63,0-.63-.36A1.36,1.36,0,0,1,270.93,203.16Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "270.935px 203.88px"
    },
    id: "el1zbjwcvxu9f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.92,197.94c.35-.2.62,0,.62.36a1.36,1.36,0,0,1-.62,1.07c-.35.2-.62,0-.62-.35A1.36,1.36,0,0,1,270.92,197.94Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "270.92px 198.655px"
    },
    id: "elndk9phrkjtd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.91,195.77c.35-.2.63,0,.63.37a1.42,1.42,0,0,1-.62,1.08c-.35.2-.63,0-.63-.36A1.39,1.39,0,0,1,270.91,195.77Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "270.915px 196.495px"
    },
    id: "el4n9s0gl5g8h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.9,190.55c.35-.2.62,0,.62.36a1.36,1.36,0,0,1-.62,1.08c-.35.2-.62,0-.62-.36A1.33,1.33,0,0,1,270.9,190.55Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "270.9px 191.27px"
    },
    id: "elfi76inut8nf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.89,188.39c.35-.2.62,0,.63.37a1.37,1.37,0,0,1-.63,1.07c-.34.2-.62,0-.62-.35A1.38,1.38,0,0,1,270.89,188.39Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "270.895px 189.11px"
    },
    id: "eljrpqoqh8p6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.86,175.78c.34-.2.62,0,.62.37a1.36,1.36,0,0,1-.62,1.07c-.35.21-.62,0-.63-.35A1.4,1.4,0,0,1,270.86,175.78Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "270.855px 176.502px"
    },
    id: "el4wyeesrcg0j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.85,173.63c.35-.2.62,0,.62.35a1.35,1.35,0,0,1-.62,1.09c-.35.2-.62,0-.62-.37A1.36,1.36,0,0,1,270.85,173.63Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "270.85px 174.35px"
    },
    id: "elobnprzf97ol",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.83,168.4c.35-.2.63,0,.63.37a1.36,1.36,0,0,1-.62,1.07c-.35.2-.63,0-.63-.35A1.39,1.39,0,0,1,270.83,168.4Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "270.835px 169.12px"
    },
    id: "elmx7ya832tgd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.83,166.24c.35-.2.62,0,.62.36a1.39,1.39,0,0,1-.62,1.09c-.35.2-.62,0-.62-.37A1.39,1.39,0,0,1,270.83,166.24Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "270.83px 166.965px"
    },
    id: "elb0ybaefvy4p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.79,153.64c.35-.21.63,0,.63.36a1.37,1.37,0,0,1-.62,1.08c-.35.2-.63,0-.63-.36A1.36,1.36,0,0,1,270.79,153.64Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "270.795px 154.358px"
    },
    id: "elm8a9ou465z",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.79,151.48c.34-.2.62,0,.62.36a1.36,1.36,0,0,1-.62,1.08c-.35.2-.62,0-.62-.36A1.33,1.33,0,0,1,270.79,151.48Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "270.79px 152.2px"
    },
    id: "eldgzi8apr0ig",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.77,146.25c.35-.2.63,0,.63.37a1.38,1.38,0,0,1-.62,1.07c-.35.21-.63,0-.63-.35A1.38,1.38,0,0,1,270.77,146.25Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "270.775px 146.972px"
    },
    id: "el5lycs5r2o7x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.77,144.1c.34-.2.62,0,.62.35a1.38,1.38,0,0,1-.62,1.09c-.35.2-.62,0-.63-.37A1.37,1.37,0,0,1,270.77,144.1Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "270.765px 144.82px"
    },
    id: "eleiwccyjrwov",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.75,138.65c.35-.2.62,0,.63.36a1.37,1.37,0,0,1-.63,1.08c-.34.2-.62,0-.62-.36A1.36,1.36,0,0,1,270.75,138.65Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "270.755px 139.37px"
    },
    id: "el7kg6xtgcoz8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.74,136.49c.35-.2.63,0,.63.36a1.34,1.34,0,0,1-.62,1.07c-.35.21-.63.05-.63-.35A1.38,1.38,0,0,1,270.74,136.49Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "270.745px 137.212px"
    },
    id: "elig6gtazyr4l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.7,121.73c.35-.2.63,0,.63.35a1.38,1.38,0,0,1-.62,1.08c-.35.2-.63,0-.63-.36A1.34,1.34,0,0,1,270.7,121.73Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "270.705px 122.445px"
    },
    id: "elnnvnn1oeq9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.68,114.34c.35-.2.63,0,.63.36a1.38,1.38,0,0,1-.63,1.08c-.34.2-.62,0-.62-.36A1.37,1.37,0,0,1,270.68,114.34Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "270.685px 115.06px"
    },
    id: "elufv51opdus",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.69,116.5c.35-.2.62,0,.62.36a1.34,1.34,0,0,1-.62,1.07c-.35.2-.62,0-.62-.35A1.35,1.35,0,0,1,270.69,116.5Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "270.69px 117.215px"
    },
    id: "elmb5d6752nho",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.71,123.88c.35-.2.62,0,.62.36a1.36,1.36,0,0,1-.62,1.08c-.35.21-.62,0-.62-.36A1.39,1.39,0,0,1,270.71,123.88Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "270.71px 124.602px"
    },
    id: "elbns27wcd15",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "304.2 205.78 304.21 210.1 277.53 225.5 277.52 221.18 304.2 205.78",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "290.865px 215.64px"
    },
    id: "elmja7k6oi9wc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295.63 203.33 295.64 207.65 277.51 218.12 277.5 213.8 295.63 203.33",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "286.57px 210.725px"
    },
    id: "el63ynhugwtar",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "304.1 168.86 304.11 173.18 298.03 176.69 298.01 172.37 304.1 168.86",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "301.06px 172.775px"
    },
    id: "els60k2g2nlqe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "301.56 185.11 301.58 189.43 277.46 203.35 277.45 199.03 301.56 185.11",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "289.515px 194.23px"
    },
    id: "elowzh0gxul59",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295.54 173.8 295.56 178.11 277.42 188.58 277.41 184.27 295.54 173.8",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "286.485px 181.19px"
    },
    id: "elcyfw8mz7pvu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "307.02 144.99 307.04 149.3 287.16 160.78 287.15 156.46 307.02 144.99",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "297.095px 152.885px"
    },
    id: "elrs055yz2hc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.99 154.71 303.01 159.02 277.38 173.82 277.37 169.5 302.99 154.71",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "290.19px 164.265px"
    },
    id: "els56qvd95kk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.6 158.51 283.61 162.83 277.36 166.44 277.35 162.12 283.6 158.51",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "280.48px 162.475px"
    },
    id: "el7d3ldrqr4ku",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.13 131.29 305.14 135.61 287.12 146.01 287.11 141.7 305.13 131.29",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "296.125px 138.65px"
    },
    id: "el4wfq9yrrtij",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.55 143.75 283.56 148.06 277.32 151.67 277.31 147.36 283.55 143.75",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "280.435px 147.71px"
    },
    id: "elvw103g2r2gr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.92 121.71 308.93 126.02 277.3 144.29 277.29 139.97 308.92 121.71",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "293.11px 133px"
    },
    id: "el22413clvjn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.12 117.43 303.13 121.75 277.28 136.68 277.26 132.36 303.12 117.43",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "290.195px 127.055px"
    },
    id: "eli7x8gtuh6f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.92 101.03 305.93 105.35 285.78 116.98 285.77 112.66 305.92 101.03",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "295.85px 109.005px"
    },
    id: "el5ky79ksl83s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.47 113.99 283.48 118.31 277.23 121.92 277.22 117.6 283.47 113.99",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "280.35px 117.955px"
    },
    id: "elycls8ts4qr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295.33 99.74 295.35 104.07 277.21 114.53 277.2 110.21 295.33 99.74",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "286.275px 107.135px"
    },
    id: "el4mvcwrer14a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "307.11 174.52 307.12 178.83 277.44 195.97 277.43 191.65 307.11 174.52",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "292.275px 185.245px"
    },
    id: "els16pkla1afa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.46 189.1 210.47 193.11 196.91 200.94 196.9 196.93 210.46 189.1",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "203.685px 195.02px"
    },
    id: "ele1crleqvq7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.42 174.93 210.43 178.93 190.85 190.24 190.84 186.23 210.42 174.93",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "200.635px 182.585px"
    },
    id: "eltk5hsm4pfo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.44 182.01 210.45 186.03 183.31 201.69 183.3 197.68 210.44 182.01",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "196.875px 191.85px"
    },
    id: "el5edoul0ufyw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.34 290.5 139.35 293.71 102.67 314.89 102.66 311.68 139.34 290.5",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "121.005px 302.695px"
    },
    id: "elo9kpzzlpz4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.16 268.51 205.17 271.73 168.48 292.91 168.47 289.69 205.16 268.51",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "186.82px 280.71px"
    },
    id: "eldpgga89yr1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.17 273.74 205.18 276.95 168.5 298.14 168.49 294.92 205.17 273.74",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "186.835px 285.94px"
    },
    id: "eltfy9zfyqvpq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.11 252.52 205.12 255.74 168.44 276.92 168.43 273.7 205.11 252.52",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "186.775px 264.72px"
    },
    id: "elsj6mk5smxk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.1 247.29 205.11 250.51 168.42 271.69 168.41 268.47 205.1 247.29",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "186.76px 259.49px"
    },
    id: "el7xmwjtjrpps",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.05 231.3 205.06 234.52 168.38 255.7 168.37 252.49 205.05 231.3",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "186.715px 243.5px"
    },
    id: "elfqveqind4bp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.04 226.07 205.05 229.28 168.36 250.47 168.35 247.25 205.04 226.07",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "186.7px 238.27px"
    },
    id: "eljujg8g6gvj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.07 207.97 190.09 211.98 173.39 221.62 173.38 217.61 190.07 207.97",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "181.735px 214.795px"
    },
    id: "elhwd1lt6sw88",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.4 311.72 139.41 314.93 102.73 336.11 102.72 332.89 139.4 311.72",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "121.065px 323.915px"
    },
    id: "elz9o3490w5sj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.38 306.48 139.39 309.71 102.71 330.88 102.7 327.66 139.38 306.48",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "121.045px 318.68px"
    },
    id: "el4hlcxcbsqhu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.21 199.06 193.22 203.06 163 220.51 162.99 216.51 193.21 199.06",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "178.105px 209.785px"
    },
    id: "elbhfagemkbxn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.32 285.26 139.33 288.49 102.65 309.66 102.64 306.44 139.32 285.26",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "120.985px 297.46px"
    },
    id: "elka1iaolwg8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.48 189.32 185.49 193.33 160.12 207.98 160.11 203.97 185.48 189.32",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "172.8px 198.65px"
    },
    id: "elxuft9kbr69n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.67 219.75 169.68 223.76 140.01 240.89 140 236.89 169.67 219.75",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "154.84px 230.32px"
    },
    id: "ell72d6qjc6bl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.28 269.28 139.29 272.49 102.61 293.67 102.6 290.46 139.28 269.28",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "120.945px 281.475px"
    },
    id: "el4s0d36cv7pv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.26 264.05 139.27 267.26 102.59 288.44 102.58 285.22 139.26 264.05",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "120.925px 276.245px"
    },
    id: "elm0831u0pms",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.11 206.28 156.12 210.29 139.95 219.62 139.94 215.62 156.11 206.28",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "148.03px 212.95px"
    },
    id: "elhhqe1t0xfqi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.67 218.43 159.68 222.43 139.99 233.8 139.98 229.79 159.67 218.43",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "149.83px 226.115px"
    },
    id: "el6nxvhnud1au",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "178.63 200.37 178.64 204.39 139.97 226.72 139.96 222.7 178.63 200.37",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "159.3px 213.545px"
    },
    id: "elcytlz9ktacs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177 183.36 177.01 188.73 139.92 210.15 139.91 204.77 177 183.36",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "158.46px 196.755px"
    },
    id: "eliaeu7i1u78",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "264.26 228.84 264.27 233.16 246.21 243.59 246.19 239.27 264.26 228.84",
    style: {
      fill: "current",
      transformOrigin: "255.23px 236.215px"
    },
    id: "elsyjhxex48xo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256.12 226.14 256.13 230.46 246.18 236.21 246.17 231.88 256.12 226.14",
    style: {
      fill: "current",
      transformOrigin: "251.15px 231.175px"
    },
    id: "el9yi0my8l6j6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "242.65 241.31 242.67 245.63 230.88 252.44 230.87 248.12 242.65 241.31",
    style: {
      fill: "current",
      transformOrigin: "236.77px 246.875px"
    },
    id: "elqtdmd27dakd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "264.19 206.69 264.21 211 246.14 221.43 246.13 217.12 264.19 206.69",
    style: {
      fill: "current",
      transformOrigin: "255.17px 214.06px"
    },
    id: "elesru2zyc1ho",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "242.63 233.93 242.65 238.25 230.86 245.06 230.84 240.73 242.63 233.93",
    style: {
      fill: "current",
      transformOrigin: "236.745px 239.495px"
    },
    id: "elzxrmrne6twf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "264.17 199.31 264.19 203.62 230.79 222.9 230.78 218.59 264.17 199.31",
    style: {
      fill: "current",
      transformOrigin: "247.485px 211.105px"
    },
    id: "el2uxeye4qbrl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "264.11 177.16 264.12 181.47 246.06 191.9 246.05 187.59 264.11 177.16",
    style: {
      fill: "current",
      transformOrigin: "255.085px 184.53px"
    },
    id: "el6p85ym8mw8v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.97 195.5 257.98 199.81 230.77 215.52 230.76 211.2 257.97 195.5",
    style: {
      fill: "current",
      transformOrigin: "244.37px 205.51px"
    },
    id: "el8glhfzb2xy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "264.09 169.78 264.1 174.09 246.04 184.52 246.03 180.21 264.09 169.78",
    style: {
      fill: "current",
      transformOrigin: "255.065px 177.15px"
    },
    id: "elymokw2y7uk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.41 157.69 259.42 162 252.18 166.19 252.16 161.87 259.41 157.69",
    style: {
      fill: "current",
      transformOrigin: "255.79px 161.94px"
    },
    id: "elgc95m7cc23f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "242.51 189.63 242.52 193.94 230.73 200.75 230.72 196.44 242.51 189.63",
    style: {
      fill: "current",
      transformOrigin: "236.62px 195.19px"
    },
    id: "elj8v96yqew2d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "242.49 182.25 242.5 186.56 230.71 193.37 230.7 189.06 242.49 182.25",
    style: {
      fill: "current",
      transformOrigin: "236.6px 187.81px"
    },
    id: "elnfofwee0u7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.97 163.72 248.98 168.03 230.67 178.6 230.66 174.29 248.97 163.72",
    style: {
      fill: "current",
      transformOrigin: "239.82px 171.16px"
    },
    id: "elexvg2tiguh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "252.14 154.49 252.16 158.8 230.65 171.22 230.63 166.91 252.14 154.49",
    style: {
      fill: "current",
      transformOrigin: "241.395px 162.855px"
    },
    id: "eluy0jstqems",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "263.96 125.25 263.98 129.57 245.91 140 245.9 135.68 263.96 125.25",
    style: {
      fill: "current",
      transformOrigin: "254.94px 132.625px"
    },
    id: "elllppn6wwhwc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "260.57 142 260.58 146.32 230.63 163.62 230.61 159.29 260.57 142",
    style: {
      fill: "current",
      transformOrigin: "245.595px 152.81px"
    },
    id: "elvo3xnpry2j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "263.94 117.87 263.96 122.19 245.89 132.62 245.88 128.3 263.94 117.87",
    style: {
      fill: "current",
      transformOrigin: "254.92px 125.245px"
    },
    id: "el99g4nlcaj5f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "242.36 137.72 242.37 142.04 230.58 148.85 230.57 144.53 242.36 137.72",
    style: {
      fill: "current",
      transformOrigin: "236.47px 143.285px"
    },
    id: "elswrlsxxan",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "242.34 130.34 242.35 134.66 230.56 141.47 230.55 137.15 242.34 130.34",
    style: {
      fill: "current",
      transformOrigin: "236.45px 135.905px"
    },
    id: "el7wtdnx3xq2y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "242.59 219.16 242.6 223.47 230.81 230.28 230.8 225.97 242.59 219.16",
    style: {
      fill: "current",
      transformOrigin: "236.7px 224.72px"
    },
    id: "ela0fz7l4u3jj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.1,73.26c1.82-1.05,3.3-.2,3.3,1.89l.4,141.12a7.19,7.19,0,0,1-3.28,5.68l-86.9,50.18c-1.82,1.05-3.31.21-3.32-1.88l-.4-141.12a7.29,7.29,0,0,1,3.29-5.69Zm2.06,144-.4-141.12c0-1-.75-1.47-1.65-.94L226.2,125.33a3.65,3.65,0,0,0-1.65,2.85L225,269.3c0,1,.75,1.46,1.66.94l86.91-50.18a3.64,3.64,0,0,0,1.64-2.84",
    style: {
      fill: "current",
      transformOrigin: "269.85px 172.696px"
    },
    id: "elxjpauifj91",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.44,273.07c2-1.17,3.69-.23,3.7,2.1a8.12,8.12,0,0,1-3.67,6.35c-2,1.17-3.68.23-3.69-2.1A8.11,8.11,0,0,1,160.44,273.07Z",
    style: {
      fill: "current",
      transformOrigin: "160.46px 277.295px"
    },
    id: "el5gg2goe5mfu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.9,295.54,210.08,262l0,15.87-58.18,33.59Zm57.39-18.19,0-14L152.72,296l0,14,56.53-32.64",
    style: {
      fill: "current",
      transformOrigin: "180.99px 286.73px"
    },
    id: "elx8nw0wwxq5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.84,274.33,210,240.74l0,15.86-58.18,33.59Zm57.39-18.2,0-14L152.66,274.8l0,14,56.53-32.64",
    style: {
      fill: "current",
      transformOrigin: "180.91px 265.465px"
    },
    id: "el00qiu2devgwqi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.78,253.11,210,219.52l.05,15.86L151.82,269Zm57.39-18.2,0-14L152.6,253.58l0,14,56.53-32.64",
    style: {
      fill: "current",
      transformOrigin: "180.915px 244.26px"
    },
    id: "el12ap5wzjeml",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.38,251.85c2-1.17,3.69-.23,3.7,2.11a8.1,8.1,0,0,1-3.67,6.34c-2,1.17-3.68.23-3.69-2.1A8.11,8.11,0,0,1,160.38,251.85Z",
    style: {
      fill: "current",
      transformOrigin: "160.4px 256.075px"
    },
    id: "eligsyo11rbe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.06,312.3l58.18-33.59,0,15.87L86.1,328.17Zm57.4-18.19,0-14L86.89,312.77l0,14,56.53-32.63",
    style: {
      fill: "current",
      transformOrigin: "115.15px 303.44px"
    },
    id: "el01wup69vt9u3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.12,333.52l58.18-33.59,0,15.87L86.16,349.39Zm57.4-18.2,0-14L87,334l0,14,56.53-32.64",
    style: {
      fill: "current",
      transformOrigin: "115.21px 324.66px"
    },
    id: "elqn20q7qkkt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.68,311c2-1.17,3.67-.23,3.68,2.11a8.05,8.05,0,0,1-3.66,6.34c-2,1.17-3.69.23-3.69-2.1A8.07,8.07,0,0,1,94.68,311Z",
    style: {
      fill: "current",
      transformOrigin: "94.685px 315.225px"
    },
    id: "eldipxfbl9h4k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.62,289.82c2-1.17,3.67-.22,3.68,2.11a8.08,8.08,0,0,1-3.66,6.34c-2,1.17-3.69.23-3.69-2.09A8.07,8.07,0,0,1,94.62,289.82Z",
    style: {
      fill: "current",
      transformOrigin: "94.625px 294.046px"
    },
    id: "elkigp3cxs6p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86,291.08l58.18-33.59,0,15.87L86,307Zm57.4-18.19,0-14L86.83,291.55l0,14,56.53-32.63",
    style: {
      fill: "current",
      transformOrigin: "115.09px 282.245px"
    },
    id: "elk2lbj6rrk4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.51 208.99 210.52 211.53 86.39 283.2 86.39 280.66 210.51 208.99",
    style: {
      fill: "current",
      transformOrigin: "148.455px 246.095px"
    },
    id: "elyxdfwkd3um",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.22,218.7c2.13-1.23,3.87-.24,3.87,2.19a8.47,8.47,0,0,1-3.84,6.66c-2.12,1.22-3.86.23-3.86-2.21A8.45,8.45,0,0,1,109.22,218.7Zm0,7a4.83,4.83,0,0,0,2.2-3.8c0-1.4-1-2-2.21-1.26a4.83,4.83,0,0,0-2.2,3.8c0,1.4,1,2,2.21,1.26",
    style: {
      fill: "current",
      transformOrigin: "109.24px 223.122px"
    },
    id: "elhd9w9sgp3d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.22,221.69l47.13-27.21.07,23.15.08,31L86.37,275.85,86.32,256Zm45.63,26-.08-28.32-6.84-3.89-16.39,28.39L98.27,238,88,255.87,88,273l43.84-25.31m-.09-31,0-19.36L87.87,222.64,88,253.19l10.3-17.84,10.27,5.85,16.39-28.41,6.84,3.9",
    style: {
      fill: "current",
      transformOrigin: "109.86px 235.165px"
    },
    id: "elj5535a8ux3q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "195.25 159.7 195.28 168.88 139.89 200.85 139.87 191.67 195.25 159.7",
    style: {
      fill: "current",
      transformOrigin: "167.575px 180.275px"
    },
    id: "elo7u6nysfzh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.82,134.05c1.37-.79,2.48-.16,2.48,1.41l0,5.29a5.44,5.44,0,0,1-2.47,4.27L88.67,213.83c-1.36.78-2.47.15-2.48-1.42v-5.29a5.4,5.4,0,0,1,2.46-4.27Z",
    style: {
      fill: "current",
      transformOrigin: "148.245px 173.937px"
    },
    id: "elays3y0u3cm6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.74,332.26c2-1.17,3.67-.23,3.68,2.11a8.05,8.05,0,0,1-3.66,6.34c-2,1.17-3.69.23-3.69-2.1A8.05,8.05,0,0,1,94.74,332.26Z",
    style: {
      fill: "current",
      transformOrigin: "94.745px 336.485px"
    },
    id: "elnha915x20j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.51,294.29c2-1.18,3.68-.23,3.69,2.1a8.12,8.12,0,0,1-3.67,6.35c-2,1.17-3.68.22-3.69-2.1A8.09,8.09,0,0,1,160.51,294.29Z",
    style: {
      fill: "current",
      transformOrigin: "160.52px 298.512px"
    },
    id: "elxhvxvt9r6ys",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.4,210.23l2-.57a18.9,18.9,0,0,1-2,5.32,3.71,3.71,0,0,1,2.71,2.82,1.54,1.54,0,0,1,2.37.69l1.56-1.37a9.12,9.12,0,0,0,2.32-3.35l2.19-5.48,1.81.19L207.25,214a13.72,13.72,0,0,1-3.6,5.17l-1.73,1.53c0,.18,0,.34,0,.52,0,.9-.06,1.82-.14,2.73l8-4.61v2.42l-8.36,4.82a28.31,28.31,0,0,1-.76,3.24l3-.82a3.18,3.18,0,0,1,3.61,1l2.22,2.94-1.8,2.29-2.22-2.94a2.06,2.06,0,0,0-2.33-.66l-3.41.94c-1.54,3.89-3.75,7.06-6.21,8.48a4.4,4.4,0,0,1-6.24-1.29l-3.41,3a9,9,0,0,0-2.32,3.35l-2.19,5.49-1.81-.2,2.19-5.49a13.81,13.81,0,0,1,3.59-5.17l3-2.64a12.81,12.81,0,0,1-.77-2.36l-8.36,4.82v-2.41l8-4.61a23.28,23.28,0,0,1-.15-2.58c0-.17,0-.34,0-.53l-1.74.48a3.16,3.16,0,0,1-3.61-1l-2.22-2.94,1.8-2.29,2.22,3a2.05,2.05,0,0,0,2.33.65l1.56-.43a6.07,6.07,0,0,1,2.36-3.42,16.33,16.33,0,0,1,2.68-5.93,5.2,5.2,0,0,1-2-3l2-1.79a3.8,3.8,0,0,0,1.76,2.49l.26.15a8.83,8.83,0,0,1,.94-.65,5.91,5.91,0,0,1,.94-.43l.27-.46A14.27,14.27,0,0,0,196.4,210.23Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "193.49px 229.945px"
    },
    id: "elkxil7hv56n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.43,166.67l1.51-.42a14,14,0,0,1-1.45,3.92,2.74,2.74,0,0,1,2,2.08,1.14,1.14,0,0,1,1.75.51l1.14-1a6.74,6.74,0,0,0,1.72-2.47l1.61-4,1.34.14-1.62,4.05a10.1,10.1,0,0,1-2.65,3.81l-1.27,1.13v.38a19.19,19.19,0,0,1-.09,2l5.88-3.4v1.79l-6.16,3.55c-.15.82-.34,1.62-.56,2.39l2.21-.6a2.32,2.32,0,0,1,2.66.74l1.64,2.17-1.33,1.69-1.64-2.17a1.53,1.53,0,0,0-1.72-.49l-2.51.7c-1.13,2.86-2.76,5.2-4.58,6.25a3.22,3.22,0,0,1-4.59-1l-2.52,2.21a6.6,6.6,0,0,0-1.71,2.47l-1.62,4.05-1.33-.15,1.61-4.05a10.32,10.32,0,0,1,2.65-3.81L178,187.2a9.71,9.71,0,0,1-.57-1.75L171.29,189v-1.78l5.88-3.4c-.06-.59-.1-1.23-.11-1.9,0-.12,0-.25,0-.39l-1.29.35a2.32,2.32,0,0,1-2.66-.74L171.5,179l1.32-1.68,1.64,2.17a1.52,1.52,0,0,0,1.72.48l1.15-.32a4.5,4.5,0,0,1,1.74-2.52,12.08,12.08,0,0,1,2-4.37,3.9,3.9,0,0,1-1.47-2.24l1.5-1.32a2.84,2.84,0,0,0,1.3,1.83l.19.11a6.12,6.12,0,0,1,.7-.47,4.78,4.78,0,0,1,.69-.33l.2-.33A10.77,10.77,0,0,0,185.43,166.67Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "183.295px 181.22px"
    },
    id: "el8dauo6umski",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.05,284.88l1.73-.48a16.19,16.19,0,0,1-1.66,4.5,3.14,3.14,0,0,1,2.29,2.39,1.31,1.31,0,0,1,2,.58l1.31-1.16a7.55,7.55,0,0,0,2-2.83l1.85-4.64,1.54.16-1.86,4.65a11.73,11.73,0,0,1-3,4.38l-1.47,1.29c0,.15,0,.29,0,.43,0,.77,0,1.55-.11,2.32l6.76-3.9v2l-7.08,4.09a24.8,24.8,0,0,1-.64,2.74l2.54-.7a2.69,2.69,0,0,1,3.06.86l1.87,2.49L155.62,306l-1.88-2.49a1.74,1.74,0,0,0-2-.55l-2.89.79c-1.3,3.29-3.17,6-5.26,7.18a3.7,3.7,0,0,1-5.27-1.1l-2.89,2.54a7.5,7.5,0,0,0-2,2.83l-1.86,4.65-1.53-.17,1.85-4.65a11.72,11.72,0,0,1,3-4.37l2.53-2.24a11.06,11.06,0,0,1-.65-2l-7.08,4.08v-2l6.76-3.9a18.66,18.66,0,0,1-.13-2.18c0-.14,0-.29,0-.45l-1.48.41a2.68,2.68,0,0,1-3-.86L130.05,299l1.52-1.93,1.88,2.49a1.76,1.76,0,0,0,2,.56l1.32-.37a5.06,5.06,0,0,1,2-2.89,13.72,13.72,0,0,1,2.26-5,4.49,4.49,0,0,1-1.68-2.57l1.73-1.52a3.22,3.22,0,0,0,1.49,2.11l.22.12a8,8,0,0,1,.79-.55,5.52,5.52,0,0,1,.8-.36l.23-.39A12.42,12.42,0,0,0,146.05,284.88Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "143.56px 301.545px"
    },
    id: "el7bdii60hmz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.11,250.17l2-.57a18.9,18.9,0,0,1-2,5.32,3.74,3.74,0,0,1,2.72,2.82,1.55,1.55,0,0,1,2.37.69l1.55-1.37a9.08,9.08,0,0,0,2.32-3.34l2.19-5.49,1.81.2L116,253.91a13.81,13.81,0,0,1-3.59,5.17l-1.73,1.53c0,.18,0,.35,0,.52,0,.91-.05,1.83-.14,2.73l8-4.61v2.42l-8.36,4.82a29,29,0,0,1-.76,3.25l3-.83a3.18,3.18,0,0,1,3.61,1l2.22,2.95-1.8,2.28-2.22-2.94a2.06,2.06,0,0,0-2.33-.66l-3.41.94c-1.54,3.89-3.75,7.06-6.21,8.48A4.38,4.38,0,0,1,96,279.68l-3.42,3A9,9,0,0,0,90.28,286l-2.19,5.49-1.81-.2,2.19-5.49a13.89,13.89,0,0,1,3.59-5.17l3-2.64a12.81,12.81,0,0,1-.77-2.36l-8.36,4.83v-2.42l8-4.61a23.24,23.24,0,0,1-.15-2.57c0-.18,0-.35,0-.54l-1.74.48a3.16,3.16,0,0,1-3.61-1l-2.22-2.94,1.8-2.28,2.22,2.94a2.05,2.05,0,0,0,2.33.65l1.57-.43a6,6,0,0,1,2.35-3.42,16.21,16.21,0,0,1,2.68-5.92,5.26,5.26,0,0,1-2-3.05l2-1.78a3.84,3.84,0,0,0,1.76,2.48l.26.15a8.83,8.83,0,0,1,.94-.65,5.91,5.91,0,0,1,.94-.43l.27-.46A14.27,14.27,0,0,0,105.11,250.17Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "102.235px 269.86px"
    },
    id: "elo6vdpehewzp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.51,178.85l2-.56a18.9,18.9,0,0,1-2,5.32,3.68,3.68,0,0,1,2.71,2.81,1.55,1.55,0,0,1,2.37.69l1.56-1.37a9,9,0,0,0,2.32-3.34l2.19-5.49,1.81.2-2.19,5.49a13.89,13.89,0,0,1-3.59,5.17L270,189.29c0,.19,0,.35,0,.52,0,.91-.05,1.83-.14,2.74l8-4.62v2.42l-8.36,4.83a28.31,28.31,0,0,1-.76,3.24l3-.82a3.16,3.16,0,0,1,3.61,1l2.22,2.94-1.8,2.28-2.22-2.94a2.05,2.05,0,0,0-2.33-.65l-3.41.94c-1.54,3.88-3.75,7.06-6.21,8.48a4.4,4.4,0,0,1-6.24-1.3l-3.41,3a9.16,9.16,0,0,0-2.32,3.34l-2.19,5.49-1.81-.2,2.19-5.48a13.81,13.81,0,0,1,3.59-5.17l3-2.64a12.81,12.81,0,0,1-.77-2.36l-8.36,4.82v-2.42l8-4.61a23,23,0,0,1-.15-2.57c0-.17,0-.35,0-.53l-1.74.48a3.18,3.18,0,0,1-3.61-1l-2.22-2.94,1.8-2.29,2.22,2.94a2.06,2.06,0,0,0,2.33.66l1.57-.43a6,6,0,0,1,2.35-3.42,16.33,16.33,0,0,1,2.68-5.93,5.2,5.2,0,0,1-2-3l2-1.79a3.83,3.83,0,0,0,1.76,2.49l.26.15a8.83,8.83,0,0,1,.94-.65,7.08,7.08,0,0,1,.94-.44l.27-.45A14.23,14.23,0,0,0,264.51,178.85Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "261.57px 198.545px"
    },
    id: "elv17ib4nrhe7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.08,162.52l1.66-.46a15.36,15.36,0,0,1-1.6,4.34,3,3,0,0,1,2.21,2.3,1.26,1.26,0,0,1,1.94.56l1.26-1.12a7.38,7.38,0,0,0,1.9-2.72l1.79-4.48,1.47.16-1.79,4.48a11.13,11.13,0,0,1-2.93,4.21L229.58,171c0,.15,0,.28,0,.42,0,.74,0,1.49-.11,2.23l6.51-3.76v2l-6.82,3.94a23,23,0,0,1-.61,2.64l2.44-.67a2.59,2.59,0,0,1,3,.82l1.81,2.4-1.47,1.86-1.81-2.39a1.69,1.69,0,0,0-1.9-.54l-2.78.77c-1.26,3.17-3.06,5.75-5.07,6.92a3.58,3.58,0,0,1-5.08-1.06L214.87,189a7.39,7.39,0,0,0-1.89,2.73l-1.79,4.48-1.47-.17,1.79-4.47a11.09,11.09,0,0,1,2.93-4.22l2.44-2.15a10.41,10.41,0,0,1-.63-1.93l-6.82,3.94v-2l6.51-3.76a19.81,19.81,0,0,1-.12-2.1c0-.14,0-.28,0-.44l-1.42.4a2.58,2.58,0,0,1-2.94-.83l-1.81-2.4,1.47-1.86,1.81,2.4a1.68,1.68,0,0,0,1.9.53l1.28-.35a4.9,4.9,0,0,1,1.92-2.79,13.35,13.35,0,0,1,2.18-4.83,4.32,4.32,0,0,1-1.62-2.48l1.67-1.46a3.12,3.12,0,0,0,1.43,2l.21.12a6.22,6.22,0,0,1,.77-.53,5.15,5.15,0,0,1,.77-.35l.22-.38A11.69,11.69,0,0,0,225.08,162.52Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "222.705px 178.575px"
    },
    id: "elpycdih2ockk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.88,114l2-.57a19.21,19.21,0,0,1-2,5.32,3.71,3.71,0,0,1,2.71,2.82,1.54,1.54,0,0,1,2.37.69l1.55-1.37a9,9,0,0,0,2.32-3.35l2.2-5.48,1.81.19-2.2,5.49a13.7,13.7,0,0,1-3.59,5.17l-1.73,1.53c0,.18,0,.34,0,.52,0,.9-.05,1.82-.13,2.73l8-4.61v2.41l-8.36,4.83a30.57,30.57,0,0,1-.75,3.24l3-.82a3.19,3.19,0,0,1,3.61,1L265,136.7,263.18,139,261,136.05a2.06,2.06,0,0,0-2.34-.66l-3.41.94c-1.53,3.89-3.74,7.06-6.21,8.48a4.38,4.38,0,0,1-6.23-1.3l-3.41,3a9,9,0,0,0-2.33,3.35l-2.19,5.49-1.81-.2,2.19-5.49a13.72,13.72,0,0,1,3.6-5.17l3-2.64a12.81,12.81,0,0,1-.77-2.36l-8.36,4.82V141.9l8-4.61c-.08-.81-.14-1.67-.15-2.58,0-.17,0-.34,0-.53l-1.74.48a3.16,3.16,0,0,1-3.61-1L233,130.71l1.8-2.29,2.22,2.94a2,2,0,0,0,2.33.66l1.57-.43a6,6,0,0,1,2.36-3.42,16.17,16.17,0,0,1,2.68-5.93,5.21,5.21,0,0,1-2-3l2-1.79a3.8,3.8,0,0,0,1.76,2.49l.26.15a7.18,7.18,0,0,1,.94-.65,6.08,6.08,0,0,1,.94-.44l.27-.45A14.77,14.77,0,0,0,251.88,114Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "248.96px 133.705px"
    },
    id: "elohek4qweou",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cones--inject-21",
    className: "animable",
    style: {
      transformOrigin: "183.798px 338.16px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187,366.27l-27.16-15.68a6.21,6.21,0,0,0-5.66,0l-27,15.68h-1.5v1.83a2,2,0,0,0,1.18,1.64l27.5,15.88a6.25,6.25,0,0,0,5.65,0l27.33-15.88a2,2,0,0,0,1.16-1.64h0v-1.83Z",
    style: {
      fill: "current",
      transformOrigin: "157.09px 368.101px"
    },
    id: "el470trhay56a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.31,364.63c1.58.91,1.58,2.37,0,3.28L160,383.79a6.22,6.22,0,0,1-5.65,0l-27.5-15.87c-1.57-.9-1.58-2.37,0-3.27l27.32-15.89a6.27,6.27,0,0,1,5.66,0Z",
    style: {
      fill: "current",
      transformOrigin: "157.082px 366.277px"
    },
    id: "elkw0uvvamjff",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el4mfi7izs3jm"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1,
      transformOrigin: "157.082px 366.277px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.31,364.63c1.58.91,1.58,2.37,0,3.28L160,383.79a6.22,6.22,0,0,1-5.65,0l-27.5-15.87c-1.57-.9-1.58-2.37,0-3.27l27.32-15.89a6.27,6.27,0,0,1,5.66,0Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "157.082px 366.277px"
    },
    id: "elddwoeh33ka5",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M149.1,341.64c4.44,2.56,11.62,2.56,16,0a6.1,6.1,0,0,0,3.24-3.95c-.78-2.2-1.53-4.27-2.2-6.11a4.94,4.94,0,0,1-2.58,3.08,14.24,14.24,0,0,1-13,0,5.07,5.07,0,0,1-2.63-3.08c-.66,1.83-1.4,3.89-2.18,6.08A6.13,6.13,0,0,0,149.1,341.64Z",
    style: {
      fill: "current",
      transformOrigin: "157.045px 337.57px"
    },
    id: "eluatc7g9823",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.63,334.66a14.24,14.24,0,0,0,13,0,4.94,4.94,0,0,0,2.58-3.08c-1.64-4.53-2.81-7.63-2.81-7.63H150.82s-1.17,3.1-2.82,7.63A5.07,5.07,0,0,0,150.63,334.66Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "157.105px 330.09px"
    },
    id: "elwpz55nff7tc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.6,348.61c5.27,3.05,13.8,3.05,19,0,2.31-1.34,3.59-3.06,3.85-4.82-.71-2.08-1.43-4.14-2.12-6.1a6.1,6.1,0,0,1-3.24,3.95c-4.41,2.56-11.59,2.56-16,0a6.13,6.13,0,0,1-3.28-4c-.69,2-1.41,4-2.12,6.1C144,345.53,145.26,347.26,147.6,348.61Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "157.07px 344.269px"
    },
    id: "elir4jsp3uodi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.1,356.27c6.11,3.53,16,3.53,22.05,0,2.88-1.68,4.36-3.85,4.49-6-.68-2.11-1.41-4.28-2.15-6.44-.26,1.76-1.54,3.48-3.85,4.82-5.24,3.05-13.77,3.05-19,0-2.34-1.35-3.63-3.08-3.9-4.85-.75,2.17-1.48,4.36-2.17,6.48C141.69,352.43,143.2,354.6,146.1,356.27Z",
    style: {
      fill: "current",
      transformOrigin: "157.105px 351.359px"
    },
    id: "el1942meargxi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.1,358.23c-.62,2.07-2.28,4-5,5.64-7.13,4.14-18.72,4.14-25.89,0-2.78-1.6-4.46-3.59-5.1-5.67a51.22,51.22,0,0,0-1.43,6.14c0,.07,0,.14,0,.21a7.14,7.14,0,0,0-.08.94h0c0,2.9,1.94,5.79,5.77,8,7.65,4.42,20,4.42,27.61,0,3.8-2.21,5.69-5.1,5.67-8h0A34.86,34.86,0,0,0,175.1,358.23Z",
    style: {
      fill: "current",
      transformOrigin: "157.125px 367.503px"
    },
    id: "elkpywmncfy2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.19,363.87c7.17,4.14,18.76,4.14,25.89,0,2.74-1.59,4.4-3.57,5-5.64-.67-2.39-1.52-5.13-2.46-8-.13,2.19-1.61,4.36-4.49,6-6.07,3.53-15.94,3.53-22.05,0-2.9-1.67-4.41-3.84-4.57-6-.93,2.86-1.77,5.58-2.44,8C139.73,360.28,141.41,362.27,144.19,363.87Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "157.075px 358.602px"
    },
    id: "elu2nnm10ieo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elgfb5kniqaw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.1,358.23c-.67-2.39-1.52-5.13-2.46-8-.68-2.11-1.41-4.28-2.15-6.44s-1.43-4.14-2.12-6.1c-.78-2.2-1.53-4.27-2.2-6.11-1.64-4.53-2.81-7.63-2.81-7.63h-5.69q1.54,5.91,3.1,11.82l1.83,7c.61,2.3,1.21,4.61,1.82,6.91l2,7.49,1.42,5.41c.19.72.37,1.45.53,2.2.67,3.17.89,6.51-1,9a7.64,7.64,0,0,1-2.78,2.2,23.53,23.53,0,0,0,6.39-2.47c3.8-2.21,5.69-5.1,5.67-8h0A34.86,34.86,0,0,0,175.1,358.23Z",
    style: {
      opacity: 0.2,
      transformOrigin: "167.16px 349.965px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M161.65,322.23c2.54,1.46,2.55,3.83,0,5.3a10.1,10.1,0,0,1-9.15,0c-2.54-1.47-2.55-3.84,0-5.3A10,10,0,0,1,161.65,322.23Z",
    style: {
      fill: "current",
      transformOrigin: "157.075px 324.874px"
    },
    id: "elizcpb2hfxgd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.41,335.17l-27.16-15.68a6.19,6.19,0,0,0-5.65,0l-27,15.68h-1.5V337a2,2,0,0,0,1.18,1.64l27.5,15.88a6.25,6.25,0,0,0,5.65,0l27.33-15.88a2,2,0,0,0,1.16-1.64h0v-1.83Z",
    style: {
      fill: "current",
      transformOrigin: "210.51px 337.001px"
    },
    id: "el07loaw5g4utw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.75,333.53c1.57.9,1.57,2.37,0,3.28l-27.33,15.88a6.22,6.22,0,0,1-5.65,0l-27.5-15.87c-1.57-.91-1.57-2.37,0-3.28l27.33-15.88a6.25,6.25,0,0,1,5.65,0Z",
    style: {
      fill: "current",
      transformOrigin: "210.51px 335.177px"
    },
    id: "elzfdequ6wq2k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elo1zxx1rfdk"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1,
      transformOrigin: "210.51px 335.177px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.75,333.53c1.57.9,1.57,2.37,0,3.28l-27.33,15.88a6.22,6.22,0,0,1-5.65,0l-27.5-15.87c-1.57-.91-1.57-2.37,0-3.28l27.33-15.88a6.25,6.25,0,0,1,5.65,0Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "210.51px 335.177px"
    },
    id: "elw4fzcj0fxzj",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M202.53,310.53c4.44,2.57,11.62,2.57,16,0a6.06,6.06,0,0,0,3.24-3.94c-.78-2.2-1.53-4.28-2.2-6.12a4.92,4.92,0,0,1-2.58,3.09,14.3,14.3,0,0,1-13,0,5,5,0,0,1-2.62-3.09c-.67,1.83-1.41,3.9-2.19,6.09A6.12,6.12,0,0,0,202.53,310.53Z",
    style: {
      fill: "current",
      transformOrigin: "210.475px 306.464px"
    },
    id: "eluef8gu43ds",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.06,303.56a14.3,14.3,0,0,0,13,0,4.92,4.92,0,0,0,2.58-3.09c-1.64-4.52-2.81-7.63-2.81-7.63H204.25s-1.17,3.1-2.81,7.63A5,5,0,0,0,204.06,303.56Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "210.54px 298.981px"
    },
    id: "elteyhp07pdan",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201,317.51c5.28,3,13.8,3,19,0,2.32-1.35,3.59-3.06,3.85-4.82-.71-2.08-1.43-4.14-2.12-6.1a6.06,6.06,0,0,1-3.24,3.94c-4.41,2.57-11.59,2.57-16,0a6.12,6.12,0,0,1-3.28-4c-.69,2-1.41,4-2.12,6.1C197.4,314.43,198.69,316.16,201,317.51Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "210.47px 313.145px"
    },
    id: "elyxeed648pz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.53,325.17c6.11,3.52,16,3.52,22.05,0,2.88-1.68,4.37-3.85,4.5-6.05-.69-2.1-1.42-4.27-2.16-6.43-.26,1.76-1.53,3.47-3.85,4.82-5.24,3-13.76,3-19,0-2.34-1.35-3.63-3.08-3.9-4.85-.75,2.17-1.48,4.36-2.17,6.47C195.12,321.33,196.63,323.49,199.53,325.17Z",
    style: {
      fill: "current",
      transformOrigin: "210.54px 320.235px"
    },
    id: "ela0qzsycjoqd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.53,327.13c-.62,2.07-2.28,4-5,5.64-7.13,4.14-18.72,4.14-25.89,0-2.78-1.6-4.46-3.6-5.1-5.67a50.78,50.78,0,0,0-1.43,6.14c0,.07,0,.14,0,.21a7,7,0,0,0-.08.94h0c0,2.9,1.94,5.79,5.77,8,7.65,4.42,20,4.42,27.61,0,3.8-2.21,5.69-5.1,5.68-8h0A34.4,34.4,0,0,0,228.53,327.13Z",
    style: {
      fill: "current",
      transformOrigin: "210.56px 336.403px"
    },
    id: "el0a53klfkndb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.62,332.77c7.17,4.14,18.76,4.14,25.89,0,2.74-1.6,4.4-3.57,5-5.64-.67-2.39-1.52-5.13-2.45-8-.13,2.2-1.62,4.37-4.5,6.05-6.07,3.52-15.94,3.52-22.05,0-2.9-1.68-4.41-3.84-4.57-6-.93,2.86-1.77,5.59-2.44,8C193.16,329.17,194.84,331.17,197.62,332.77Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "210.505px 327.502px"
    },
    id: "elm1iwoshq1y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elovfubr0gr99"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.53,327.13c-.67-2.39-1.52-5.13-2.45-8-.69-2.1-1.42-4.27-2.16-6.43s-1.43-4.14-2.12-6.1c-.78-2.2-1.53-4.28-2.2-6.12-1.64-4.52-2.81-7.63-2.81-7.63H211.1q1.54,5.91,3.1,11.82l1.83,7q.91,3.45,1.82,6.91c.66,2.49,1.31,5,2,7.48.47,1.81,1,3.62,1.42,5.42.19.71.37,1.45.53,2.2.67,3.17.89,6.51-1,9a7.56,7.56,0,0,1-2.78,2.2,23.6,23.6,0,0,0,6.39-2.47c3.8-2.21,5.69-5.1,5.68-8h0A34.4,34.4,0,0,0,228.53,327.13Z",
    style: {
      opacity: 0.2,
      transformOrigin: "220.595px 318.865px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M215.08,291.12c2.54,1.47,2.55,3.84,0,5.31a10.1,10.1,0,0,1-9.15,0c-2.54-1.47-2.55-3.84,0-5.31A10.1,10.1,0,0,1,215.08,291.12Z",
    style: {
      fill: "current",
      transformOrigin: "210.505px 293.775px"
    },
    id: "ellwujtqadnfh",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-21",
    className: "animable",
    style: {
      transformOrigin: "378.797px 254.303px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M401.09,248.6H406S411.65,285.87,412,293a.63.63,0,0,1-.36.51,2,2,0,0,1-1.76,0,.59.59,0,0,1-.34-.45h0C408.88,288.81,401.09,248.6,401.09,248.6Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "406.545px 271.157px"
    },
    id: "elwt5cgxcrwib",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elbazs53umwrq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M406,248.6s.24,1.61.63,4.19c-.78,1.68-2.48,3.5-4,3.54-.6-3.14-1.49-7.73-1.49-7.73Z",
    style: {
      opacity: 0.3,
      transformOrigin: "403.885px 252.465px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M406.57,279.85h-4.89s-5.67,37.27-6.06,44.41a.63.63,0,0,0,.36.51,2,2,0,0,0,1.76,0,.59.59,0,0,0,.34-.45h0C398.78,320.06,406.57,279.85,406.57,279.85Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "401.095px 302.412px"
    },
    id: "elv5m76e5wp6r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elmnk0r8nmj4l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M401.68,279.85s-.24,1.61-.63,4.19a13.05,13.05,0,0,0,4.53.94c.6-3.14,1-5.13,1-5.13Z",
    style: {
      opacity: 0.3,
      transformOrigin: "403.815px 282.415px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M427.88,263.71h4.88s5.68,37.27,6.07,44.41a.62.62,0,0,1-.37.51,2,2,0,0,1-1.76,0,.68.68,0,0,1-.34-.45h0C435.66,303.92,427.88,263.71,427.88,263.71Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "433.355px 286.272px"
    },
    id: "elvw43ydetbxc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elsvvqjal4xb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M432.76,263.71s.25,1.61.63,4.19c-.77,1.67-2.47,3.5-4,3.54-.6-3.14-1.49-7.73-1.49-7.73Z",
    style: {
      opacity: 0.3,
      transformOrigin: "430.645px 267.575px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M377.66,263.2h-4.88s-5.67,37.26-6.07,44.41a.66.66,0,0,0,.37.51,2,2,0,0,0,1.76,0,.65.65,0,0,0,.34-.45h0C369.88,303.41,377.66,263.2,377.66,263.2Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "372.185px 285.762px"
    },
    id: "elols4h0iw70q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el8smxpkfmd6s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M372.78,263.2l-.63,4.18c.83,1,2.66,2.51,4.21,2.55.61-3.13,1.3-6.73,1.3-6.73Z",
    style: {
      opacity: 0.3,
      transformOrigin: "374.905px 266.565px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "431.06 230.61 428.91 257.77 431.52 259.74 433.87 231.76 431.06 230.61",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "431.39px 245.175px"
    },
    id: "eliops574ffv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "403.51 215.07 401.37 242.23 403.98 244.19 406.32 216.21 403.51 215.07",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "403.845px 229.63px"
    },
    id: "elf8742zxrpa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.93,238.71S380.61,243.3,368,255.4v5c2.32,2.78,20,16.54,38.54,22.25,12.4-5.71,24.67-15.3,26.78-17.91v-4.95C428.69,250.62,396.93,238.71,396.93,238.71Z",
    style: {
      fill: "current",
      transformOrigin: "400.66px 260.68px"
    },
    id: "elppeirfpbocm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eljbdpiuak2m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M368,255.4v5c2.32,2.78,20,16.54,38.54,22.25v-5C388,271.94,370.35,258.18,368,255.4Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "387.27px 269.025px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el3odnxkgelpp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M406.57,277.65v5c12.4-5.71,24.67-15.3,26.78-17.91v-4.95C431.24,262.35,419,271.94,406.57,277.65Z",
    style: {
      opacity: 0.2,
      transformOrigin: "419.96px 271.22px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M439.89,225a2.16,2.16,0,0,0-.32-1.11c-10.88-17.05-33.43-22.32-38.43-21l-2.33,2.37v12.22c17.39,2.22,32.31,13.56,38.33,22.3l.81-.31a3.1,3.1,0,0,0,1.95-2.87V225Z",
    style: {
      fill: "current",
      transformOrigin: "419.355px 221.238px"
    },
    id: "elmardmmthr98",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eltt8zv8zbt1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M439.89,225a2.16,2.16,0,0,1-1.41,2.05l-1.34.48v12.22l.81-.31a3.1,3.1,0,0,0,1.95-2.87V225Z",
    style: {
      opacity: 0.1,
      transformOrigin: "438.52px 232.375px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elk6r1gqnjujf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437.14,227.57l1.34-.48a2.16,2.16,0,0,0,1.09-3.16c-10.88-17.05-33.43-22.32-38.43-21l-2.33,2.37C403.82,204.34,428.61,209.3,437.14,227.57Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "419.351px 215.153px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el64bi52te75p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M398.81,205.27v12.22c17.39,2.22,32.31,13.56,38.33,22.3V227.57C428.61,209.3,403.82,204.34,398.81,205.27Z",
    style: {
      opacity: 0.3,
      transformOrigin: "417.975px 222.477px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M382.68,213.31l-.17,11.42-19.09,13.56-5.65,2.38a9.64,9.64,0,0,0-4.95,4.71l-3.25,6.76a2.14,2.14,0,0,0,1.4,3h0a4.68,4.68,0,0,0,4.34-1.08l4-3.7,1.11-.4a16.9,16.9,0,0,0,8.12-6.08h0L391,235.19A8.57,8.57,0,0,0,396.13,225l-3.71-13.81Z",
    style: {
      fill: "rgb(140, 74, 74)",
      transformOrigin: "372.891px 233.24px"
    },
    id: "el144idowif7rb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.44 311.64 343.74 318.46 340.69 320.94 334.37 316.29 337.15 307.72 345.44 311.64",
    style: {
      fill: "rgb(140, 74, 74)",
      transformOrigin: "339.905px 314.33px"
    },
    id: "elg8qfspz7lq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.74,314.41a22.4,22.4,0,0,0,3.59,1,2.21,2.21,0,0,1,1.67,1.34,12.89,12.89,0,0,1,.78,3c.3.13.64-.08.88-.3a5,5,0,0,0,.79-1,2.19,2.19,0,0,1,1-.83l1.42-.6c-.58,1.42-.3,3.32-.08,4.83a7.18,7.18,0,0,1-.36,4.5,1.94,1.94,0,0,1-.88.82,8.25,8.25,0,0,1-1.2.35,8.15,8.15,0,0,0-4.05,3.27,36.49,36.49,0,0,1-3.15,4.25c-2.91,3-7.6,3.57-11.56,3.21a9.07,9.07,0,0,1-3.59-1,4.42,4.42,0,0,1-2.27-2.84,5,5,0,0,1,2-4.63,27.37,27.37,0,0,1,4.65-2.59,21,21,0,0,0,7.59-6.82,6.56,6.56,0,0,0,1.05-2.73c.09-.7.21-1.55.26-2.37A1.07,1.07,0,0,1,334.74,314.41Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "331.345px 326.339px"
    },
    id: "elyp50ek5x0x7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.44,242.56l-26.66,15.62a18.19,18.19,0,0,0-8.42,11.15l-10.28,39.78a28.1,28.1,0,0,1,10,3.69c8.92-16.27,16.22-28.23,16.33-35.54l26.94-15.79Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "362.715px 277.68px"
    },
    id: "elgkgcubvipkj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.71 324.13 363 330.95 359.96 333.43 353.64 328.78 356.42 320.21 364.71 324.13",
    style: {
      fill: "rgb(140, 74, 74)",
      transformOrigin: "359.175px 326.82px"
    },
    id: "elz7bldifmncj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.44,242.56l7.94,18.91-15.89,8.89a18.17,18.17,0,0,0-8.42,11.14l-10.28,39.78a28,28,0,0,1,10,3.7c8.93-16.28,16.51-31.44,16.62-38.75l29.69-17.51a19.26,19.26,0,0,0,9.44-15.35l.65-9.94Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "387.99px 283.77px"
    },
    id: "elqhdjtfy004l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354,326.9a22.4,22.4,0,0,0,3.59,1,2.21,2.21,0,0,1,1.67,1.34,12.89,12.89,0,0,1,.78,3.05c.3.13.64-.08.88-.31a4.93,4.93,0,0,0,.79-1,2.22,2.22,0,0,1,1-.83l1.43-.6c-.58,1.42-.3,3.31-.08,4.83a7.19,7.19,0,0,1-.36,4.5,1.87,1.87,0,0,1-.88.81,7,7,0,0,1-1.21.36,8.17,8.17,0,0,0-4,3.27,36.49,36.49,0,0,1-3.15,4.25c-2.91,3-7.6,3.57-11.56,3.21a9.08,9.08,0,0,1-3.59-1A4.37,4.37,0,0,1,337,347a5,5,0,0,1,2.05-4.63,27.37,27.37,0,0,1,4.65-2.59,21,21,0,0,0,7.59-6.82,6.41,6.41,0,0,0,1-2.73c.1-.7.22-1.55.27-2.38A1.06,1.06,0,0,1,354,326.9Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "350.616px 338.852px"
    },
    id: "elrile30zt5zh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.31,195.5c-9.16-.1-11.59,3.7-10.16,25.65,2.75,1.15,5.76.91,7.23,0S392.31,195.5,392.31,195.5Z",
    style: {
      fill: "current",
      transformOrigin: "387.04px 208.712px"
    },
    id: "el0treebw4lje",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.85,241.93s-.18,3-7.32,7-20.28,3.27-33.09-6.33c3.83-6.34,4-16.86,2.85-31.39s5.44-16.25,11.56-15.67l11.07.59,9.61,1C426.22,217,421.85,241.93,421.85,241.93Z",
    style: {
      fill: "current",
      transformOrigin: "402.136px 223.332px"
    },
    id: "elli85kzd07h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.73,185.4,396,191.07v3.62a2.47,2.47,0,0,1-.15.81,15.89,15.89,0,0,0,6.45-2.58A10.36,10.36,0,0,0,406.73,185.4Z",
    style: {
      fill: "rgb(105, 43, 43)",
      transformOrigin: "401.29px 190.45px"
    },
    id: "eluq2d86xsgkq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.73,185.4a10.36,10.36,0,0,1-4.43,7.52,15.89,15.89,0,0,1-6.45,2.58,3.56,3.56,0,0,1-.52.93,2.4,2.4,0,0,0-.41,1.7,2.62,2.62,0,0,0,1.51,1.9,5.19,5.19,0,0,0,2.47.42,10.37,10.37,0,0,0,8-4.36V185.3Z",
    style: {
      fill: "rgb(140, 74, 74)",
      transformOrigin: "400.899px 192.882px"
    },
    id: "el8k7sg4mv0ki",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.43,172.19a6.64,6.64,0,0,1-4.24-1.38,6.48,6.48,0,0,1-1.68-2,.89.89,0,0,1,1-1.29,7.06,7.06,0,0,0,2.51,0,11.86,11.86,0,0,1-2.34-8.84,1.13,1.13,0,0,1,1.6-.84,21.89,21.89,0,0,0,11.1,2.24c2-.14,4-.57,6.09-.73a11.22,11.22,0,0,1,6,.91,5.72,5.72,0,0,1,3.28,4.83,2.76,2.76,0,0,1,2-1.17,3.06,3.06,0,0,1,2.36.7c-1.18.64-2.33,1.3-3.51,1.94,1.21-.43,2.73.52,3.33,1.65a8.22,8.22,0,0,1,.65,3.76,30,30,0,0,1-.23,5.1,9.82,9.82,0,0,1-1.94,4.68,7.41,7.41,0,0,1-3.51,2.38,9.57,9.57,0,0,1-5.7-.18,23,23,0,0,1-5.18-2.59A81.34,81.34,0,0,1,383.43,172.19Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "394.502px 171.105px"
    },
    id: "el7p8methpxam",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.18,168.79a39.12,39.12,0,0,0,2.25,21,7.47,7.47,0,0,0,2.85,4c1.5.86,3.37.68,5.08.42a26.17,26.17,0,0,0,8-2.26,11,11,0,0,0,5.56-6,4.83,4.83,0,0,0,4.87-1.91,9.19,9.19,0,0,0,1.58-5.32c0-1.2-.23-2.63-1.31-3.16a3,3,0,0,0-3.08.77,9.22,9.22,0,0,0-3,4.5c-.8-2.93-2-5.76-2.83-8.69a4.93,4.93,0,0,0-1.7-3c-1.23-.79-2.84-.34-4.26,0A27.87,27.87,0,0,1,383.18,168.79Z",
    style: {
      fill: "rgb(140, 74, 74)",
      transformOrigin: "398.005px 181.563px"
    },
    id: "eldo5yan9iqmc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "391.72 177.68 388.29 183.45 392.38 184.22 391.72 177.68",
    style: {
      fill: "rgb(105, 43, 43)",
      transformOrigin: "390.335px 180.95px"
    },
    id: "elsilsjh6xqrh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.11,186.39l-2.66,1.29a1.71,1.71,0,0,0,2,.57A1.56,1.56,0,0,0,396.11,186.39Z",
    style: {
      fill: "rgb(105, 43, 43)",
      transformOrigin: "394.826px 187.38px"
    },
    id: "elift6qqw41de",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.64,177.91a1.17,1.17,0,1,1-1.28-1A1.17,1.17,0,0,1,397.64,177.91Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "396.482px 178.074px"
    },
    id: "el72cevoa9evx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.8,178.52a1.18,1.18,0,1,1-1.29-1.05A1.18,1.18,0,0,1,387.8,178.52Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "386.627px 178.644px"
    },
    id: "eln2jdfraynyq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.19,174l-2.41,2a1.68,1.68,0,0,1,.32-1.88A2,2,0,0,1,386.19,174Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "384.907px 174.881px"
    },
    id: "ela4g739jpjej",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.18,172.84l2.77,1.53a1.67,1.67,0,0,0-.69-1.78A2,2,0,0,0,396.18,172.84Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "397.589px 173.388px"
    },
    id: "elpyccfdglceg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.45,263.41a1,1,0,0,1,0,.38v0a2.1,2.1,0,0,1-.15.3l0,0a2.32,2.32,0,0,1-.26.3h0a2,2,0,0,1-.39.28l-21.36,12.41a3.05,3.05,0,0,1-.61.27l-.24.08-.31.07-.38.07h-.09a4.41,4.41,0,0,1-.52,0H382a4.41,4.41,0,0,1-.52,0h-.08l-.5-.08-.08,0a2.7,2.7,0,0,1-.43-.13l-.08,0a2.93,2.93,0,0,1-.47-.23l-35.24-20.34a2.37,2.37,0,0,1-.4-.28,1.09,1.09,0,0,1-.1-.11c-.06-.07-.13-.13-.18-.2l-.07-.14a.75.75,0,0,1-.1-.2.58.58,0,0,1,0-.14,1.38,1.38,0,0,1,0-.2v1.25a1.38,1.38,0,0,0,0,.2.58.58,0,0,0,0,.14.75.75,0,0,0,.1.2l.07.14c.05.07.12.13.18.2a1.09,1.09,0,0,0,.1.11,2.37,2.37,0,0,0,.4.28l35.24,20.34a2.93,2.93,0,0,0,.47.23l.08,0a2.7,2.7,0,0,0,.43.13l.08,0,.5.08h.08a4.41,4.41,0,0,0,.52,0h.08a4.41,4.41,0,0,0,.52,0h.09l.38-.07.31-.07.24-.08a3.05,3.05,0,0,0,.61-.27L405.57,266a2,2,0,0,0,.39-.28h0a2.32,2.32,0,0,0,.26-.3l0,0a2.1,2.1,0,0,0,.15-.3v0a.86.86,0,0,0,0-.28h0v-1.35Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "375.107px 267.174px"
    },
    id: "elm5xx92wdyyk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.73,255.88a.75.75,0,0,0,.1.2l.07.14c.05.07.12.13.18.2a1.09,1.09,0,0,0,.1.11,2.37,2.37,0,0,0,.4.28l35.24,20.34a2.93,2.93,0,0,0,.47.23l.08,0a2.7,2.7,0,0,0,.43.13l.08,0,.5.08h.08a4.41,4.41,0,0,0,.52,0h.08a4.41,4.41,0,0,0,.52,0h.09l.38-.07.31-.07.24-.08a3.05,3.05,0,0,0,.61-.27l21.36-12.41a2,2,0,0,0,.39-.28h0a2.32,2.32,0,0,0,.26-.3l0,0a2.1,2.1,0,0,0,.15-.3v0a1,1,0,0,0,0-.38,1.61,1.61,0,0,0-.9-1.21l-35.24-20.34a4.83,4.83,0,0,0-4.38,0l-21.35,12.41a1.54,1.54,0,0,0-.91,1.27,1.38,1.38,0,0,0,0,.2A.58.58,0,0,0,343.73,255.88Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "374.987px 259.476px"
    },
    id: "elvctsu42dlhp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.66,255.54l34.23,19.76.13.07.08,0a1.12,1.12,0,0,0,.27.08l.18,0h.13l.34,0h0l.35,0,.22,0,.28-.08a1.22,1.22,0,0,0,.24-.1l11-6.4-35.36-20.41Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "370.385px 261.955px"
    },
    id: "eleh8pjkcsrd9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.06,275.54h0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "382.06px 275.54px"
    },
    id: "el66vli30d2io",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.22,250.1l-6.44,3.79a.66.66,0,0,0,0,1.13l9.63,5.56a1.07,1.07,0,0,0,1.08,0l6.43-3.79a.65.65,0,0,0,0-1.12l-9.63-5.56A1.09,1.09,0,0,0,379.22,250.1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "381.351px 255.345px"
    },
    id: "el5tvknsnjxxo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.8,275.89l-3.65-23.19a4.28,4.28,0,0,0-2.07-3L340.6,229a1,1,0,0,0-.94-.06h0l-.85.42.29.11a1,1,0,0,0-.09.63l3.64,23.19a4.31,4.31,0,0,0,2.08,3L380.21,277a.94.94,0,0,0,.23.1l0,.34.82-.4h0A1.05,1.05,0,0,0,381.8,275.89Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "360.317px 253.145px"
    },
    id: "elpq47o6rdhhe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.36,250l-35.47-20.63a1.07,1.07,0,0,0-1.6,1.09l3.65,23.2a4.25,4.25,0,0,0,2.08,3l35.47,20.63a1.07,1.07,0,0,0,1.6-1.09l-3.65-23.19A4.27,4.27,0,0,0,375.36,250Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "359.69px 253.33px"
    },
    id: "elecglbjglq1q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.17,250.62a7.82,7.82,0,0,1,3.52,5.07c.23,1.81-1,2.48-2.68,1.49a7.86,7.86,0,0,1-3.52-5.07C355.26,250.3,356.46,249.63,358.17,250.62Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "358.59px 253.9px"
    },
    id: "el3dp91ukv0jf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el4j7o8vz3rou"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "410.98 212.45 417.03 239.26 420.54 239.26 419.8 218.92 410.98 212.45",
    style: {
      opacity: 0.1,
      transformOrigin: "415.76px 225.855px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M415.87,225.52l3.12,10.7L399.9,249.78l-5.65,2.38a9.67,9.67,0,0,0-4.95,4.71l-3.25,6.76a2.15,2.15,0,0,0,1.4,3h0a4.71,4.71,0,0,0,4.34-1.09l4-3.7,1.11-.39a17,17,0,0,0,8.12-6.09h0l22.38-8.69a8.57,8.57,0,0,0,5.17-10.21l-3.71-13.81Z",
    style: {
      fill: "rgb(140, 74, 74)",
      transformOrigin: "409.353px 244.713px"
    },
    id: "elpbn9osrhi6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.55,211.17l5.53,16.55c9,.62,13.21-2.41,14.46-5.09-4.73-21.5-7.85-25.07-14-25.51S410.55,211.17,410.55,211.17Z",
    style: {
      fill: "current",
      transformOrigin: "420.545px 212.456px"
    },
    id: "elmvlmbmi6k4r",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-21",
    className: "animable",
    style: {
      transformOrigin: "230.646px 310.513px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.78,321.64l-145-106.9c2.86-6.06.1-15.29-7.27-22.66a29,29,0,0,0-13.4-7.88c-5-1.17-9.27-.26-12.1,2.57-5.66,5.65-3.32,16.85,5.32,25.49a28.86,28.86,0,0,0,13.39,7.89,17.84,17.84,0,0,0,4.06.49,11.19,11.19,0,0,0,7.62-2.68l145,106.9a2,2,0,0,0,1.19.39,2,2,0,0,0,1.19-3.61ZM156.2,209.43c-6.82-6.81-9.26-15.9-5.32-19.83a7.14,7.14,0,0,1,5.22-1.89c4.39,0,10,2.6,14.62,7.2,6.82,6.82,9.25,15.9,5.31,19.84S163,216.25,156.2,209.43Z",
    style: {
      fill: "current",
      transformOrigin: "235.76px 254.476px"
    },
    id: "elzaso57twdgh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elb8mp9zlefhf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.78,321.64l-145-106.9c2.86-6.06.1-15.29-7.27-22.66a29,29,0,0,0-13.4-7.88c-5-1.17-9.27-.26-12.1,2.57-5.66,5.65-3.32,16.85,5.32,25.49a28.86,28.86,0,0,0,13.39,7.89,17.84,17.84,0,0,0,4.06.49,11.19,11.19,0,0,0,7.62-2.68l145,106.9a2,2,0,0,0,1.19.39,2,2,0,0,0,1.19-3.61ZM156.2,209.43c-6.82-6.81-9.26-15.9-5.32-19.83a7.14,7.14,0,0,1,5.22-1.89c4.39,0,10,2.6,14.62,7.2,6.82,6.82,9.25,15.9,5.31,19.84S163,216.25,156.2,209.43Z",
    style: {
      opacity: 0.2,
      transformOrigin: "235.76px 254.476px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M172.49,193.14c-7.91-7.91-18.4-10.29-23.37-5.32-4.7,4.38-10.84,11.05-9.9,18.29a34.2,34.2,0,0,0,.7,3.49c.57,2.47,1.11,4.8.54,7.09a15.11,15.11,0,0,1-2.62,4.89,22.41,22.41,0,0,0-2.28,3.73,11.61,11.61,0,0,0,2.81,12.86c0,.25,0,.5.07.74l.29-.43a9.82,9.82,0,0,0,1.1.82,10.9,10.9,0,0,0,5.83,1.63,11.44,11.44,0,0,0,8.63-3.79,22.11,22.11,0,0,0,2.05-3,18.51,18.51,0,0,1,2.22-3.15c1.95-2.08,4.77-3.14,7.49-4.16l1.71-.65c3.37-1.34,10.05-8.11,11.52-11.69l0-.06C182.17,208.9,179.31,200,172.49,193.14Zm5.32,9.4a44.58,44.58,0,0,1-3.9,5.93A25.87,25.87,0,0,0,167,198.25l3.68-5.48q.57.53,1.14,1.08A28.73,28.73,0,0,1,177.81,202.54ZM140,228.86c.22-.43.46-.86.72-1.28a13.76,13.76,0,0,1,3.83,2.24l-5.26,7.83a9.63,9.63,0,0,1-1-1A16.57,16.57,0,0,1,140,228.86Zm1.28-2.15c.61-.91,1.26-1.8,1.9-2.67a42.5,42.5,0,0,0,2.63-3.83,17.85,17.85,0,0,1,3.7,2.23L145.12,229A14.82,14.82,0,0,0,141.28,226.71Zm0-15.78a29.67,29.67,0,0,1,5.94.75,19.14,19.14,0,0,1-.89,5.19,13.67,13.67,0,0,1-.91,2.07,19.8,19.8,0,0,0-4.22-1.14,8.57,8.57,0,0,0,.27-.86A13.27,13.27,0,0,0,141.24,210.93Zm24.39-12.5-5.18,7.71a23.78,23.78,0,0,0-10.82-4.77,28.61,28.61,0,0,1,4.62-8.17A24.94,24.94,0,0,1,165.63,198.43ZM155,192.32l.38-.46a54.16,54.16,0,0,1,5-5,25.83,25.83,0,0,1,9.5,5.26l-3.69,5.5A26,26,0,0,0,155,192.32Zm-6.34,8.89a23.83,23.83,0,0,0-8.08.34,22.36,22.36,0,0,1,4.8-8.4,25.62,25.62,0,0,1,7.77-.13A29.26,29.26,0,0,0,148.63,201.21Zm0,4.08a20.78,20.78,0,0,1,.69-3A22.83,22.83,0,0,1,159.89,207l-4.84,7.22-.7-.52a20.86,20.86,0,0,0-6.13-2.75c0-.37,0-.75.05-1.12A42.6,42.6,0,0,1,148.63,205.29Zm5.16,9.21c.24.16.47.34.7.52l-4.42,6.58a19.77,19.77,0,0,0-3.77-2.27,15.64,15.64,0,0,0,.94-2.13,20.17,20.17,0,0,0,.92-5.26A19.84,19.84,0,0,1,153.79,214.5Zm-3.51,8.57.47.42a17.82,17.82,0,0,1,2.57,3c-1,1.35-2,2.76-2.92,4.16-.58.88-1.18,1.76-1.79,2.63a14,14,0,0,0-2.4-3.31l-.34-.32Zm1.16-.31c-.19-.18-.39-.35-.59-.52l4.42-6.59a17.58,17.58,0,0,1,4.11,5.23,30.17,30.17,0,0,0-4.13,3.36c-.45.46-.88.94-1.29,1.43A18.87,18.87,0,0,0,151.44,222.76Zm4.39-7.94,4.84-7.2.14.12a22.32,22.32,0,0,1,5.66,8.22c-.5.39-1,.78-1.53,1.16-1,.71-2,1.4-3.05,2.07q-.84.54-1.68,1.11A18.63,18.63,0,0,0,155.83,214.82Zm5.65-7.82c-.08-.08-.17-.14-.25-.21l5.16-7.7a24.88,24.88,0,0,1,6.78,10.3,44.45,44.45,0,0,1-5.89,5.91A23.21,23.21,0,0,0,161.48,207Zm-11.66-18.47a8.67,8.67,0,0,1,6.31-2.33,14.79,14.79,0,0,1,3.09.35,53.47,53.47,0,0,0-4.63,4.65c-.26.31-.5.61-.74.92a26.54,26.54,0,0,0-7.5-.11C147.51,190.74,148.71,189.57,149.82,188.53Zm-9.51,14.11a22.72,22.72,0,0,1,8-.47,22.7,22.7,0,0,0-.68,3,42.49,42.49,0,0,0-.37,4.62c0,.3,0,.6,0,.9a31.54,31.54,0,0,0-6.21-.74c-.05-.18-.09-.36-.13-.54-.26-1.12-.53-2.28-.68-3.4A11.3,11.3,0,0,1,140.31,202.64Zm-1.65,19.51a23.19,23.19,0,0,0,2.1-3.4,18.24,18.24,0,0,1,4.12,1.07,42.67,42.67,0,0,1-2.5,3.62c-.7.95-1.41,1.91-2.06,2.92a15.45,15.45,0,0,0-3.81-.72A22.14,22.14,0,0,1,138.66,222.15Zm-2.53,4.49a13.64,13.64,0,0,1,3.64.59c-.23.39-.46.78-.66,1.18a17.38,17.38,0,0,0-1.81,6.92A10.68,10.68,0,0,1,136.13,226.64Zm4,11.62,5.22-7.77.2.17a13.43,13.43,0,0,1,2.44,3.55l-.06.09a19.46,19.46,0,0,1-5.49,5.1,9.15,9.15,0,0,1-2-1Zm3.58,1.48a20.06,20.06,0,0,0,4.74-4.5,14.56,14.56,0,0,1,.91,4.07A10.86,10.86,0,0,1,143.66,239.74Zm9.87-3.26a9.67,9.67,0,0,1-3.25,2.43,15.06,15.06,0,0,0-1.18-4.61c.74-1,1.45-2.08,2.13-3.11.85-1.28,1.72-2.58,2.66-3.82a18.67,18.67,0,0,1,2.16,5.34c-.2.3-.38.61-.57.91A20.89,20.89,0,0,1,153.53,236.48Zm4.3-6.18a12.87,12.87,0,0,0-1,1.3,19.61,19.61,0,0,0-2.25-5.06c.46-.56.92-1.09,1.42-1.59a28.08,28.08,0,0,1,3.87-3.16,18.22,18.22,0,0,1,1.53,5.93A13.15,13.15,0,0,0,157.83,230.3Zm9.56-5.05-1.69.64c-1.13.43-2.28.86-3.39,1.37a19,19,0,0,0-1.66-6l1.79-1.19c1-.67,2.07-1.37,3.08-2.09.45-.32.89-.66,1.32-1a23.27,23.27,0,0,1,1.32,7.92A6.21,6.21,0,0,1,167.39,225.25Zm1.77-1a24.4,24.4,0,0,0-1.49-8,45,45,0,0,0,5.87-5.76,25.37,25.37,0,0,1,1,8.88A35.36,35.36,0,0,1,169.16,224.24Zm9.21-10.18-.18.37,0,0a19.25,19.25,0,0,1-2.62,3.77,26.62,26.62,0,0,0-1.3-8.63,44.32,44.32,0,0,0,4-5.87C179.72,207.59,179.84,211.31,178.37,214.06Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "157.549px 213.078px"
    },
    id: "el0czj4ja9jwe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.92,432.34c-.68,2.15-3,3.38-5.28,3.55s-4.46-.45-6.68-.85c-5-.9-9.74,0-14.69-.12a21.16,21.16,0,0,1-4.83-.53,8,8,0,0,1-4.13-2.43,5.49,5.49,0,0,1-1.19-2.59,5.12,5.12,0,0,0,1.19,4,8,8,0,0,0,4.13,2.43,21.16,21.16,0,0,0,4.83.53c5,.11,9.73-.78,14.69.12,2.22.4,4.43,1,6.68.85s4.6-1.4,5.28-3.55a5.65,5.65,0,0,0,.17-2.28A4.7,4.7,0,0,1,280.92,432.34Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "262.607px 433.347px"
    },
    id: "el5c1veqtac1t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.79,428.23c-.3-1.5-.61-3-.91-4.5a6.58,6.58,0,0,0-.77-2.3,2.25,2.25,0,0,0-2-1.14c-2.72-.37-6.54-1.35-8.79.21A20.29,20.29,0,0,1,256.17,424c-2.24-.08-4.49-.54-6.72-.27s-4.55,1.52-5.21,3.66a4.33,4.33,0,0,0-.12,2,5.49,5.49,0,0,0,1.19,2.59,8,8,0,0,0,4.13,2.43,21.16,21.16,0,0,0,4.83.53c5,.11,9.73-.78,14.69.12,2.22.4,4.43,1,6.68.85s4.6-1.4,5.28-3.55a4.7,4.7,0,0,0,.17-.83A10.44,10.44,0,0,0,280.79,428.23Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "262.585px 427.789px"
    },
    id: "el0izpe0waz2k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.66,415.78l-.2,5.87a2.33,2.33,0,0,0,2.16,2.4,37.65,37.65,0,0,0,5.92-.06,3.35,3.35,0,0,0,3-3.15l.23-4.33Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "273.114px 419.959px"
    },
    id: "elqcp59g3rjm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306,412.65a4.62,4.62,0,0,1-.79,2.43,4.41,4.41,0,0,1-2.77,1.56,7,7,0,0,1-6.88-2.83c-.73-1.07-1.16-2.33-1.85-3.42a15.47,15.47,0,0,0-3.86-3.75,16.19,16.19,0,0,1-3.88-3.73,5.5,5.5,0,0,1-.75-5,4.19,4.19,0,0,0-.36.62,5.66,5.66,0,0,0,.7,5.29,16.61,16.61,0,0,0,4,3.84,16.06,16.06,0,0,1,3.94,3.86c.71,1.13,1.14,2.43,1.89,3.53a7.13,7.13,0,0,0,7,2.92,4.5,4.5,0,0,0,2.82-1.61A5.39,5.39,0,0,0,306,413C306,412.9,306,412.78,306,412.65Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "295.261px 407.989px"
    },
    id: "elnu9k5x9lf7c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.2,405.28c-1.78-3.12-5.46-5.4-8.3-7.61a10.62,10.62,0,0,0-5.5-2.5,5.17,5.17,0,0,0-5.13,2.61,1.15,1.15,0,0,1-.06.17,5.5,5.5,0,0,0,.75,5,16.19,16.19,0,0,0,3.88,3.73,15.47,15.47,0,0,1,3.86,3.75c.69,1.09,1.12,2.35,1.85,3.42a7,7,0,0,0,6.88,2.83,4.41,4.41,0,0,0,2.77-1.56,4.62,4.62,0,0,0,.79-2.43c0-.28,0-.56,0-.84A13.74,13.74,0,0,0,304.2,405.28Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "295.453px 405.957px"
    },
    id: "elhfkb7kup60m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.47,402.57v5.34a9,9,0,0,0,8.3-.37l.5-4.8Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "300.87px 405.659px"
    },
    id: "elhi9stmb9su5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.67,305.78c1.6,4.8-.37,27.6-1.3,49.48,3.47,8.27,2.53,31.74.53,48.41,0,0-3.47,2.14-9.73,0l-7.87-46-1.1-26s-2,23.07-4.24,37.88c2.14,11.34,1.6,13.47-3.67,48.34a13.15,13.15,0,0,1-11.8,0c-3-49-1.88-93.64-1.32-109.69Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "286.592px 362.534px"
    },
    id: "el4n332ayj7on",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.37,276.52l2.3,4.85-5.5,6.05.4,14.46,17.74-15.41a4.81,4.81,0,0,0,1.18-5.7l-5.42-11.25Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "315.065px 285.7px"
    },
    id: "elre4ze34eyyc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.84,285.7a11.12,11.12,0,0,1-3.17-4.33l-1.37,1.51A7.1,7.1,0,0,0,313.84,285.7Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "311.57px 283.535px"
    },
    id: "el4mxpd8um4zi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.93,277.69c7-.62,11.84-7.92,11.84-7.92-6.3-12.91-11.8-27.26-22.8-23.84Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "308.37px 261.554px"
    },
    id: "el5aq3jl2rike",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.22,269v40.54c23.88,10,39.35,1,41.45-3.73-1.1-16.51,2.8-35.81,2.5-44s-1.31-17.44-14-15.59l-13.53,1.32-6.86,1.67Z",
    style: {
      fill: "current",
      transformOrigin: "287.203px 280.025px"
    },
    id: "elhib1fkagfdf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.59,215.94c-2.9-1.09-5.73-5.26-2.83-7.09.81-.6,3.17.1,5.07,0-1.67-1.5-2.07-3.3-1.24-3.87s3.07,1.57,7.12,1.17,18-4.9,19.76,5.3a2.68,2.68,0,0,1,4.1-.7l-2.9,2.05c4.3,6,2.9,13-7.52,26.89A7.66,7.66,0,0,1,285,241.16l-4.3-10.61-4.2-5.1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "287.557px 223.636px"
    },
    id: "elqebwavh8sb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "272.63 224.42 269.82 229.29 272.89 230.42 272.63 224.42",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "271.355px 227.42px"
    },
    id: "elbi59abxtqkf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.59,215.94a45.23,45.23,0,0,0-.8,20.69,7,7,0,0,0,1.28,3.27,5.11,5.11,0,0,0,3.56,1.64,15.35,15.35,0,0,0,4-.38v6.33c4.81,1.14,9.76,1.59,13.53-1.32v-6.48a17.37,17.37,0,0,1-8.4.53c-3.32-1.8-4-7.86-3.52-9.47a2.5,2.5,0,0,0,2.6.92A3.48,3.48,0,0,0,288,230a7.18,7.18,0,0,0,.81-2.69,4.91,4.91,0,0,0-.5-3.34,3.49,3.49,0,0,0-3.76-1.27,5.37,5.37,0,0,0-3.16,2.65,7.8,7.8,0,0,0-.56,1.21.75.75,0,0,1-1.46-.19,10,10,0,0,1,.95-5.3,3.65,3.65,0,0,1-2.71-1.66,3.44,3.44,0,0,1-.52-3A10.31,10.31,0,0,1,273.59,215.94Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "283.558px 232.153px"
    },
    id: "elre7oeognt1q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.87,347.49,287,326.28c5.48,0,10.57-4.1,14.44-8-3.72,6.62-10.92,9.55-10.92,9.55Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "294.22px 332.885px"
    },
    id: "elmwq8d9ca5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.9,279.32s.8-3.95,3-6.22l-1.34-1.78C243.53,273.19,242.1,276.84,242.9,279.32Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "244.283px 275.32px"
    },
    id: "el3jv4zybg1fe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.76,249.16l-.25,0a19.27,19.27,0,0,0-11.26,5.4l-13.7,13.48s.11.32.35.85a23.4,23.4,0,0,0,9.5,10.41c.25.15.49.3.76.44l12.73-11.7S280.56,261.86,274.76,249.16Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "263.239px 264.45px"
    },
    id: "elickrmndk0r9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.9,268.92l-4,4.18c-2.18,2.27-3,6.22-3,6.22-.8-2.48.63-6.13,1.64-8l1.34,1.78L230.75,253l-1.05-4.33a2,2,0,0,0-1-1.31l-1-.5a4,4,0,0,0-2.69-.33l-.81.19,2.75,2-1.88.72-3.66.16-4-2.95-.11.36a8,8,0,0,0,.38,5.46l1.35,3.05a4,4,0,0,0,1.93,2l3.54,1.69,15.5,26a7.18,7.18,0,0,0,10.92,1.69l8.5-7.56A23.4,23.4,0,0,1,249.9,268.92Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "238.205px 267.567px"
    },
    id: "elqzvv26p9v1",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-21",
    className: "animable",
    style: {
      transformOrigin: "127.075px 90.82px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.86,108.2l-.35.32Z",
    style: {
      fill: "none",
      transformOrigin: "108.685px 108.36px"
    },
    id: "elu9pj1ioidyr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.64,106c.32-.15.64-.31,1-.5s.67-.41,1-.63l.32-.23.66-.5.35-.29.6-.52.35-.33.44-.44c.24-.24.47-.49.7-.74l.39-.46.41-.49.48-.61.29-.39.52-.75c.06-.1.13-.2.2-.3q.35-.53.66-1.08l.1-.18c.18-.31.35-.62.51-.94.05-.1.11-.21.16-.32.17-.33.33-.67.48-1l.06-.13c.16-.38.32-.77.46-1.15l.12-.34c.1-.28.2-.56.29-.84s.08-.29.13-.44.13-.49.2-.74.09-.36.13-.54.07-.38.11-.57.1-.56.14-.83.07-.5.09-.75,0-.25,0-.37c0-.39,0-.78,0-1.16a13,13,0,0,0-.1-1.44,11.41,11.41,0,0,0-1.41.69C99.75,90,95.07,98.08,95.09,104.71a11.13,11.13,0,0,0,.1,1.45l.21-.08Z",
    style: {
      fill: "none",
      transformOrigin: "101.044px 96.08px"
    },
    id: "elx4hnssmiq6s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.94,86.69c.09.09.19.17.28.27C114.13,86.86,114,86.78,113.94,86.69Z",
    style: {
      fill: "none",
      transformOrigin: "114.08px 86.825px"
    },
    id: "eljw9r4rkq29",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.19,111.44h0Z",
    style: {
      fill: "none",
      transformOrigin: "98.19px 111.44px"
    },
    id: "elprmcak2inq8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.9,109.83l-.31.23Z",
    style: {
      fill: "none",
      transformOrigin: "106.745px 109.945px"
    },
    id: "eli5fivvevh1s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.3,86.16a3.62,3.62,0,0,1,.32.22A3.62,3.62,0,0,0,113.3,86.16Z",
    style: {
      fill: "none",
      transformOrigin: "113.46px 86.27px"
    },
    id: "elq8nqy1qtjks",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.69,89.93c0,.14.08.27.11.41C115.77,90.2,115.73,90.07,115.69,89.93Z",
    style: {
      fill: "none",
      transformOrigin: "115.745px 90.135px"
    },
    id: "el3l0ft3a5jmx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.91,91.07c0,.12,0,.24,0,.37C116,91.31,115.92,91.19,115.91,91.07Z",
    style: {
      fill: "none",
      transformOrigin: "115.931px 91.255px"
    },
    id: "el3j25o8gi138",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,88.09a4,4,0,0,1,.2.35A4,4,0,0,0,115,88.09Z",
    style: {
      fill: "none",
      transformOrigin: "115.1px 88.265px"
    },
    id: "el45bfhfr49ug",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.39,89a3.34,3.34,0,0,1,.15.38A3.34,3.34,0,0,0,115.39,89Z",
    style: {
      fill: "none",
      transformOrigin: "115.465px 89.19px"
    },
    id: "eldolt4uvpf6r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.5,87.33a3.65,3.65,0,0,1,.24.31A3.65,3.65,0,0,0,114.5,87.33Z",
    style: {
      fill: "none",
      transformOrigin: "114.62px 87.485px"
    },
    id: "elvivczty42np",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.67,70.7q.3,0,.6,0-.3,0-.6,0Z",
    style: {
      fill: "none",
      transformOrigin: "115.97px 70.7px"
    },
    id: "elqeblrbtim2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.83,80.73c.08-.09.16-.19.25-.28h0C97,80.54,96.91,80.64,96.83,80.73Z",
    style: {
      fill: "none",
      transformOrigin: "96.955px 80.59px"
    },
    id: "elcmgeoxu014c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,107c-.23.26-.46.5-.7.74C109.54,107.51,109.77,107.27,110,107Z",
    style: {
      fill: "none",
      transformOrigin: "109.65px 107.37px"
    },
    id: "el9vod148bi0j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.7,70.7h0Z",
    style: {
      fill: "none",
      transformOrigin: "114.7px 70.7px"
    },
    id: "elr01iu42t14g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.85,98.86c0,.11-.09.23-.13.34C114.76,99.09,114.8,99,114.85,98.86Z",
    style: {
      fill: "none",
      transformOrigin: "114.785px 99.03px"
    },
    id: "el0i96dz99p2rh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.09,101.9h0c.07-.26.13-.52.21-.78h0C85.22,101.38,85.16,101.64,85.09,101.9Z",
    style: {
      fill: "none",
      transformOrigin: "85.195px 101.51px"
    },
    id: "elcarzjbjgedp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98,79.53l.38-.38h0Z",
    style: {
      fill: "none",
      transformOrigin: "98.19px 79.34px"
    },
    id: "el80gy5ewu0bi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.46,104.53c.07-.35.16-.71.24-1.06h0C84.62,103.82,84.53,104.18,84.46,104.53Z",
    style: {
      fill: "none",
      transformOrigin: "84.58px 104px"
    },
    id: "elxuih9cutuc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.56,112.11a1.21,1.21,0,0,0,.19,0h-.19Z",
    style: {
      fill: "none",
      transformOrigin: "100.655px 112.112px"
    },
    id: "elju4fb3010p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.09,104.31h0l.2-.3h0Z",
    style: {
      fill: "none",
      transformOrigin: "112.19px 104.16px"
    },
    id: "eluz8jat664c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113,102.94h0a1.74,1.74,0,0,0,.1-.19h0A1.74,1.74,0,0,1,113,102.94Z",
    style: {
      fill: "none",
      transformOrigin: "113.05px 102.845px"
    },
    id: "elxv5g6zzhn0r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.86,111.75l.19.07h0Z",
    style: {
      fill: "none",
      transformOrigin: "98.955px 111.785px"
    },
    id: "el3v4o8cjaz9v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.56,101.82c0-.11.11-.21.16-.32,0,.11-.11.21-.16.31Z",
    style: {
      fill: "none",
      transformOrigin: "113.64px 101.66px"
    },
    id: "elst0w5jljli8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.46,96.84h0c0-.18.09-.35.13-.53h0C115.55,96.49,115.5,96.66,115.46,96.84Z",
    style: {
      fill: "none",
      transformOrigin: "115.525px 96.575px"
    },
    id: "elhmt41uh8zl6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.93,94.15a13,13,0,0,0,.09-1.52c0,.38,0,.76,0,1.15C116,93.9,116,94,115.93,94.15Z",
    style: {
      fill: "none",
      transformOrigin: "115.975px 93.39px"
    },
    id: "elfml6q4ahdkp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.2,100.49h0l.06-.14h0Z",
    style: {
      fill: "none",
      transformOrigin: "114.23px 100.42px"
    },
    id: "elfomb7vtojr5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.7,95.73h0c0-.27.1-.55.14-.83h0C115.8,95.18,115.75,95.46,115.7,95.73Z",
    style: {
      fill: "none",
      transformOrigin: "115.77px 95.315px"
    },
    id: "elftivkt7sq1k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.13,98l.13-.43-.13.43Z",
    style: {
      fill: "none",
      transformOrigin: "115.195px 97.785px"
    },
    id: "elo5fx898ceng",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.28,105.46h0l.29-.4h0Z",
    style: {
      fill: "none",
      transformOrigin: "111.425px 105.26px"
    },
    id: "elwsnf132pnn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.25,112a3.29,3.29,0,0,0,.43-.09h0A3.15,3.15,0,0,1,102.25,112Z",
    style: {
      fill: "none",
      transformOrigin: "102.465px 111.955px"
    },
    id: "el6cd0hmke4wx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.39,112.1l.32,0h0Z",
    style: {
      fill: "none",
      transformOrigin: "101.55px 112.1px"
    },
    id: "el0n1tfzhytg1b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.62,112l.17,0h0Z",
    style: {
      fill: "none",
      transformOrigin: "99.705px 112px"
    },
    id: "elg40ip0a4ewr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.14,111.76c.24-.07.49-.16.74-.25h0C103.62,111.6,103.38,111.69,103.14,111.76Z",
    style: {
      fill: "none",
      transformOrigin: "103.51px 111.635px"
    },
    id: "el64234yt1gn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.56,109.34l-.35.26c.35-.27.69-.55,1-.84l-.32.28Z",
    style: {
      fill: "none",
      transformOrigin: "107.71px 109.18px"
    },
    id: "elj5bz6ipd80s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.39,111.3a9.69,9.69,0,0,0,1.2-.61c-.32.19-.64.35-1,.5Z",
    style: {
      fill: "none",
      transformOrigin: "104.99px 110.995px"
    },
    id: "el0xeir7yukxc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.4,106.56h0c.14-.16.27-.33.4-.5h0C110.67,106.23,110.54,106.4,110.4,106.56Z",
    style: {
      fill: "none",
      transformOrigin: "110.6px 106.31px"
    },
    id: "el5j8okhq0fhv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6,126.61l-.84,1,8.07,4.7-1.69-6.31A15.05,15.05,0,0,1,94.6,126.61Z",
    style: {
      fill: "current",
      transformOrigin: "97.795px 129.155px"
    },
    id: "elijjn3hq8txg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.62,80.2,133,78.46l-8.1-4.7-.55,1.42A15.11,15.11,0,0,1,126.62,80.2Z",
    style: {
      fill: "current",
      transformOrigin: "128.675px 76.98px"
    },
    id: "elp230f32vjjr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.91,91.07c0-.25-.06-.5-.11-.73s-.07-.27-.11-.41-.09-.4-.15-.59a3.34,3.34,0,0,0-.15-.38c-.07-.18-.13-.36-.2-.52a4,4,0,0,0-.2-.35c-.08-.15-.16-.31-.25-.45a3.65,3.65,0,0,0-.24-.31,3.58,3.58,0,0,0-.28-.37c-.09-.1-.19-.18-.28-.27s-.21-.22-.32-.31a3.62,3.62,0,0,0-.32-.22c-1.62-1.13-3.85-1.26-6.37-.2a13,13,0,0,1,.1,1.44c0,.38,0,.77,0,1.16,0,.12,0,.24,0,.37s0,.5-.09.75-.09.55-.14.83-.07.38-.11.57-.09.36-.13.54-.13.5-.2.74-.09.29-.13.44-.19.56-.29.84l-.12.34c-.14.38-.3.77-.46,1.15l-.06.13c-.15.34-.31.68-.48,1,0,.11-.11.22-.16.32-.16.32-.33.63-.51.94l-.1.18q-.31.56-.66,1.08c-.07.1-.14.2-.2.3l-.52.75-.29.39-.48.61-.41.49-.39.46c-.23.25-.46.5-.7.74l-.44.44-.35.33-.6.52-.35.29-.66.5-.32.23q-.48.33-1,.63c-.32.19-.64.35-1,.5l-.24.11-.21.08c.3,2.54,1.39,4.36,3,5.28h0a5.11,5.11,0,0,0,.67.31l.15.06h0a4.74,4.74,0,0,0,.57.16l.15,0h0a4.91,4.91,0,0,0,.77.09h.19c.21,0,.42,0,.64,0l.3,0h0l.54-.09a3.15,3.15,0,0,0,.42-.09h0l.46-.13c.24-.07.48-.16.73-.25h0l.51-.21.24-.11c.32-.15.64-.31,1-.5s.67-.4,1-.63l.31-.23a3.55,3.55,0,0,0,.31-.23l.35-.26.36-.3.32-.28.27-.24.35-.32.44-.45c.24-.24.47-.48.7-.74l.4-.45h0c.14-.16.27-.33.4-.5h0l.48-.6h0l.29-.4h0c.18-.24.35-.49.52-.75h0l.2-.3h0c.23-.35.45-.71.66-1.07h0a1.74,1.74,0,0,0,.1-.19h0q.27-.47.51-.93h0c0-.1.11-.2.16-.31.17-.33.33-.67.48-1h0l.06-.14h0c.16-.38.32-.76.46-1.15,0-.11.08-.23.13-.34.09-.28.19-.56.28-.84h0l.13-.43c.07-.25.13-.5.2-.75h0c0-.18.09-.35.13-.53h0c0-.19.07-.38.11-.58h0c0-.27.1-.55.14-.83h0q.06-.37.09-.75c0-.12,0-.25,0-.37,0-.39,0-.77,0-1.15a11.28,11.28,0,0,0-.06-1.19C116,91.31,115.92,91.19,115.91,91.07Z",
    style: {
      fill: "current",
      transformOrigin: "105.585px 98.6421px"
    },
    id: "els24qj3jgpcg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.58 66.76 118.58 61.53 113.17 58.45 122.16 63.67 127.58 66.76",
    style: {
      fill: "current",
      transformOrigin: "120.375px 62.605px"
    },
    id: "eltelfph4bac9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.2 118.32 78.17 118.87 77.28 118.35 74.55 125.35 83.54 130.57 86.82 122.17 80.2 118.32",
    style: {
      fill: "current",
      transformOrigin: "80.685px 124.445px"
    },
    id: "elrudr68l6wkc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.78 66.83 116.51 70.74 122.16 63.67 113.17 58.45 108.37 64.44 109.28 64.98 109.78 66.83",
    style: {
      fill: "current",
      transformOrigin: "115.265px 64.595px"
    },
    id: "elme35zkg4xv9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5,117.15l-4.3,1.17,6.62,3.85A14.63,14.63,0,0,1,84.5,117.15Z",
    style: {
      fill: "current",
      transformOrigin: "83.51px 119.66px"
    },
    id: "elw0sclvxjds",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,71.28a16.37,16.37,0,0,1,3.73-.58h.19c.26,0,.52,0,.78,0h0q.3,0,.6,0h.24l-6.73-3.91Z",
    style: {
      fill: "current",
      transformOrigin: "113.175px 69.035px"
    },
    id: "el67pcnolpap",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7,103.47h0c.12-.52.25-1,.39-1.57h0c.07-.26.13-.52.21-.78h0c.41-1.42.89-2.85,1.45-4.26l-9-5.23L77.6,92l-.23.66c-.14.38-.28.76-.41,1.14l-.09.25c-.06.18-.11.37-.17.55-.14.43-.27.85-.39,1.28,0,.12-.08.24-.11.35s-.07.28-.1.43q-.21.78-.39,1.56c0,.15-.08.31-.11.46s-.09.41-.13.61l9,5.22C84.53,104.18,84.62,103.82,84.7,103.47Z",
    style: {
      fill: "current",
      transformOrigin: "81.11px 98.07px"
    },
    id: "elng89ilh0x5b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.48,83.45c.75-.94,1.54-1.85,2.35-2.72.08-.09.16-.19.25-.28h0l.9-.92.38-.38h0c.54-.53,1.08-1,1.64-1.53l-9-5.23c-.56.49-1.1,1-1.64,1.54l-.15.14c-.25.24-.5.5-.74.76l-.39.4c-.43.45-.84.91-1.25,1.38l0,0c-.46.52-.9,1.05-1.33,1.6h0Z",
    style: {
      fill: "current",
      transformOrigin: "92.75px 77.92px"
    },
    id: "elwzo8j47ucn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.46 104.53 75.47 99.31 69.15 104.88 78.14 110.1 84.46 104.53",
    style: {
      fill: "current",
      transformOrigin: "76.805px 104.705px"
    },
    id: "el0ta2uuhbsck",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.14 110.1 69.15 104.88 69.18 113.65 77.28 118.35 78.17 118.87 78.14 110.1",
    style: {
      fill: "current",
      transformOrigin: "73.66px 111.875px"
    },
    id: "elvcbr58uj8j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.65 69.38 92.66 64.16 91.01 72.39 100 77.61 101.65 69.38",
    style: {
      fill: "current",
      transformOrigin: "96.33px 70.885px"
    },
    id: "el6z54vvvr4q8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.28 64.98 108.37 64.44 100.29 59.75 92.66 64.16 101.65 69.38 109.28 64.98",
    style: {
      fill: "current",
      transformOrigin: "100.97px 64.565px"
    },
    id: "ellgpg6iy9wm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.43 92.25 74.44 87.02 77.75 91.63 86.75 96.86 83.43 92.25",
    style: {
      fill: "current",
      transformOrigin: "80.595px 91.94px"
    },
    id: "elyftu5zkwpjq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.48 83.45 85.49 78.23 85.49 78.23 79.82 77.71 88.81 82.93 94.48 83.45",
    style: {
      fill: "current",
      transformOrigin: "87.15px 80.58px"
    },
    id: "elgdoxsf9pvcu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.81 82.93 79.82 77.71 74.44 87.02 83.43 92.25 88.81 82.93",
    style: {
      fill: "current",
      transformOrigin: "81.625px 84.98px"
    },
    id: "el6vs8j4iy0yh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.65,92.81,133,87.23l0-8.77-6.33,1.74a15.11,15.11,0,0,0-2.32-5l.55-1.42,2.73-7-5.42-3.09-5.65,7.07h-.24q-.3,0-.6,0c-.26,0-.52,0-.78,0h-.19a16.37,16.37,0,0,0-3.73.58l-1.19-4.45-.5-1.85-7.63,4.4L100,77.62c-.56.49-1.1,1-1.64,1.53l-.38.38-.9.92c-.09.09-.17.19-.25.28-.81.87-1.6,1.78-2.35,2.72l-5.67-.52-5.38,9.32,3.32,4.61c-.56,1.41-1,2.84-1.45,4.26-.08.26-.14.52-.21.78-.14.52-.27,1-.39,1.57-.08.35-.17.71-.24,1.06l-6.32,5.57,0,8.77,2-.55,4.3-1.17a14.63,14.63,0,0,0,2.32,5l-3.28,8.4L89,133.66l4.81-6,.84-1a15.05,15.05,0,0,0,5.54-.56l1.69,6.31,7.63-4.41,1.65-8.23a45.08,45.08,0,0,0,5.52-5.83l5.68.51,5.38-9.31-3.32-4.6A45.62,45.62,0,0,0,126.65,92.81Zm-10.72,1.34q0,.38-.09.75c0,.28-.09.56-.14.83s-.07.39-.11.58-.09.35-.13.53-.13.5-.2.75l-.13.43c-.09.28-.19.56-.28.84,0,.11-.09.23-.13.34-.14.39-.3.77-.46,1.15l-.06.14c-.15.34-.31.68-.48,1,0,.11-.11.21-.16.32q-.24.47-.51.93a1.74,1.74,0,0,1-.1.19c-.21.36-.43.72-.66,1.07l-.2.3c-.17.26-.34.51-.52.75l-.29.4-.48.6c-.13.17-.26.34-.4.5l-.4.45c-.23.26-.46.5-.7.74l-.44.45-.35.32-.27.24c-.34.29-.68.57-1,.84a3.55,3.55,0,0,1-.31.23l-.31.23c-.33.23-.66.44-1,.63a9.69,9.69,0,0,1-1.2.61l-.51.21c-.25.09-.5.18-.74.25l-.46.13a3.29,3.29,0,0,1-.43.09l-.54.09-.32,0c-.22,0-.43,0-.64,0a1.21,1.21,0,0,1-.19,0,4.91,4.91,0,0,1-.77-.09l-.17,0a4.74,4.74,0,0,1-.57-.16l-.19-.07a5.11,5.11,0,0,1-.67-.31h0c-1.6-.92-2.69-2.74-3-5.28a11.13,11.13,0,0,1-.1-1.45c0-6.63,4.66-14.73,10.43-18.06a11.41,11.41,0,0,1,1.41-.69c2.52-1.06,4.75-.93,6.37.2a3.62,3.62,0,0,1,.32.22c.11.09.21.2.32.31s.19.17.28.27a3.58,3.58,0,0,1,.28.37,3.65,3.65,0,0,1,.24.31c.09.14.17.3.25.45a4,4,0,0,1,.2.35c.07.16.13.34.2.52a3.34,3.34,0,0,1,.15.38c.06.19.1.39.15.59s.08.27.11.41.07.48.11.73,0,.24,0,.37a11.28,11.28,0,0,1,.06,1.19A13,13,0,0,1,115.93,94.15Z",
    style: {
      fill: "current",
      transformOrigin: "105.57px 98.675px"
    },
    id: "elwoafr1tlmw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elwllwy33g2hb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.6,126.61l-.84,1,8.07,4.7-1.69-6.31A15.05,15.05,0,0,1,94.6,126.61Z",
    style: {
      opacity: 0.2,
      transformOrigin: "97.795px 129.155px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elvz1fairr5mk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.62,80.2,133,78.46l-8.1-4.7-.55,1.42A15.11,15.11,0,0,1,126.62,80.2Z",
    style: {
      opacity: 0.2,
      transformOrigin: "128.675px 76.98px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el0tbvvgbg94tr"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.91,91.07c0-.25-.06-.5-.11-.73s-.07-.27-.11-.41-.09-.4-.15-.59a3.34,3.34,0,0,0-.15-.38c-.07-.18-.13-.36-.2-.52a4,4,0,0,0-.2-.35c-.08-.15-.16-.31-.25-.45a3.65,3.65,0,0,0-.24-.31,3.58,3.58,0,0,0-.28-.37c-.09-.1-.19-.18-.28-.27s-.21-.22-.32-.31a3.62,3.62,0,0,0-.32-.22c-1.62-1.13-3.85-1.26-6.37-.2a13,13,0,0,1,.1,1.44c0,.38,0,.77,0,1.16,0,.12,0,.24,0,.37s0,.5-.09.75-.09.55-.14.83-.07.38-.11.57-.09.36-.13.54-.13.5-.2.74-.09.29-.13.44-.19.56-.29.84l-.12.34c-.14.38-.3.77-.46,1.15l-.06.13c-.15.34-.31.68-.48,1,0,.11-.11.22-.16.32-.16.32-.33.63-.51.94l-.1.18q-.31.56-.66,1.08c-.07.1-.14.2-.2.3l-.52.75-.29.39-.48.61-.41.49-.39.46c-.23.25-.46.5-.7.74l-.44.44-.35.33-.6.52-.35.29-.66.5-.32.23q-.48.33-1,.63c-.32.19-.64.35-1,.5l-.24.11-.21.08c.3,2.54,1.39,4.36,3,5.28h0a5.11,5.11,0,0,0,.67.31l.15.06h0a4.74,4.74,0,0,0,.57.16l.15,0h0a4.91,4.91,0,0,0,.77.09h.19c.21,0,.42,0,.64,0l.3,0h0l.54-.09a3.15,3.15,0,0,0,.42-.09h0l.46-.13c.24-.07.48-.16.73-.25h0l.51-.21.24-.11c.32-.15.64-.31,1-.5s.67-.4,1-.63l.31-.23a3.55,3.55,0,0,0,.31-.23l.35-.26.36-.3.32-.28.27-.24.35-.32.44-.45c.24-.24.47-.48.7-.74l.4-.45h0c.14-.16.27-.33.4-.5h0l.48-.6h0l.29-.4h0c.18-.24.35-.49.52-.75h0l.2-.3h0c.23-.35.45-.71.66-1.07h0a1.74,1.74,0,0,0,.1-.19h0q.27-.47.51-.93h0c0-.1.11-.2.16-.31.17-.33.33-.67.48-1h0l.06-.14h0c.16-.38.32-.76.46-1.15,0-.11.08-.23.13-.34.09-.28.19-.56.28-.84h0l.13-.43c.07-.25.13-.5.2-.75h0c0-.18.09-.35.13-.53h0c0-.19.07-.38.11-.58h0c0-.27.1-.55.14-.83h0q.06-.37.09-.75c0-.12,0-.25,0-.37,0-.39,0-.77,0-1.15a11.28,11.28,0,0,0-.06-1.19C116,91.31,115.92,91.19,115.91,91.07Z",
    style: {
      opacity: 0.2,
      transformOrigin: "105.585px 98.6421px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ela0otyg07ae"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "80.2 118.32 78.17 118.87 77.28 118.35 74.55 125.35 83.54 130.57 86.82 122.17 80.2 118.32",
    style: {
      opacity: 0.2,
      transformOrigin: "80.685px 124.445px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el4lo7g0jrdx"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.5,117.15l-4.3,1.17,6.62,3.85A14.63,14.63,0,0,1,84.5,117.15Z",
    style: {
      opacity: 0.2,
      transformOrigin: "83.51px 119.66px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el0cn1r84ndkza"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111,71.28a16.37,16.37,0,0,1,3.73-.58h.19c.26,0,.52,0,.78,0h0q.3,0,.6,0h.24l-6.73-3.91Z",
    style: {
      opacity: 0.2,
      transformOrigin: "113.175px 69.035px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el8co1444946h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.7,103.47h0c.12-.52.25-1,.39-1.57h0c.07-.26.13-.52.21-.78h0c.41-1.42.89-2.85,1.45-4.26l-9-5.23L77.6,92l-.23.66c-.14.38-.28.76-.41,1.14l-.09.25c-.06.18-.11.37-.17.55-.14.43-.27.85-.39,1.28,0,.12-.08.24-.11.35s-.07.28-.1.43q-.21.78-.39,1.56c0,.15-.08.31-.11.46s-.09.41-.13.61l9,5.22C84.53,104.18,84.62,103.82,84.7,103.47Z",
    style: {
      opacity: 0.2,
      transformOrigin: "81.11px 98.07px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ell6r2vghoxb"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "78.14 110.1 69.15 104.88 69.18 113.65 77.28 118.35 78.17 118.87 78.14 110.1",
    style: {
      opacity: 0.2,
      transformOrigin: "73.66px 111.875px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elwovyceh1z7k"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "101.65 69.38 92.66 64.16 91.01 72.39 100 77.61 101.65 69.38",
    style: {
      opacity: 0.2,
      transformOrigin: "96.33px 70.885px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el2onzdvljc13"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "83.43 92.25 74.44 87.02 77.75 91.63 86.75 96.86 83.43 92.25",
    style: {
      opacity: 0.2,
      transformOrigin: "80.595px 91.94px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elfvue6ubxqsn"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "94.48 83.45 85.49 78.23 85.49 78.23 79.82 77.71 88.81 82.93 94.48 83.45",
    style: {
      opacity: 0.2,
      transformOrigin: "87.15px 80.58px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elja67h3qqg3p"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "109.78 66.83 116.51 70.74 122.16 63.67 113.17 58.45 108.37 64.44 109.28 64.98 109.78 66.83",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "115.265px 64.595px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elqa2fcgculzd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.48,83.45c.75-.94,1.54-1.85,2.35-2.72.08-.09.16-.19.25-.28h0l.9-.92.38-.38h0c.54-.53,1.08-1,1.64-1.53l-9-5.23c-.56.49-1.1,1-1.64,1.54l-.15.14c-.25.24-.5.5-.74.76l-.39.4c-.43.45-.84.91-1.25,1.38l0,0c-.46.52-.9,1.05-1.33,1.6h0Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "92.75px 77.92px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elrrh1cn0cmb"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "84.46 104.53 75.47 99.31 69.15 104.88 78.14 110.1 84.46 104.53",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "76.805px 104.705px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elds3szua2fnr"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "109.28 64.98 108.37 64.44 100.29 59.75 92.66 64.16 101.65 69.38 109.28 64.98",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "100.97px 64.565px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elynf9uyxyfdb"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "88.81 82.93 79.82 77.71 74.44 87.02 83.43 92.25 88.81 82.93",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "81.625px 84.98px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M168,83.17l-.25.23Z",
    style: {
      fill: "none",
      transformOrigin: "167.875px 83.285px"
    },
    id: "elyqy0tf9f0hg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.62,81.59a7.17,7.17,0,0,0,.67-.35c.24-.14.48-.29.71-.45l.22-.16.47-.35.25-.21.42-.36.25-.24.31-.31c.16-.17.33-.34.49-.52l.28-.32L163,78l.34-.42.2-.28.37-.53a1.64,1.64,0,0,0,.14-.22c.16-.25.32-.5.47-.75,0-.05.05-.09.07-.14q.19-.33.36-.66a2.26,2.26,0,0,0,.11-.22c.12-.24.24-.48.34-.72a.36.36,0,0,0,0-.09c.12-.27.23-.55.33-.82l.09-.24c.07-.2.14-.4.2-.6l.09-.3c.05-.18.1-.35.14-.53s.07-.25.1-.38,0-.27.08-.4.07-.4.1-.59l.06-.53,0-.26c0-.28,0-.55,0-.82a8.17,8.17,0,0,0-.07-1,7,7,0,0,0-1,.49,16.22,16.22,0,0,0-7.38,12.77,8.52,8.52,0,0,0,.06,1l.15-.06Z",
    style: {
      fill: "none",
      transformOrigin: "162.365px 74.63px"
    },
    id: "eld59bnbsrcw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.56,68l.2.19Z",
    style: {
      fill: "none",
      transformOrigin: "171.66px 68.095px"
    },
    id: "elheqkhg0usel",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.42,85.46h0Z",
    style: {
      fill: "none",
      transformOrigin: "160.42px 85.46px"
    },
    id: "elmocfdq0lte",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.58,84.33l-.22.16Z",
    style: {
      fill: "none",
      transformOrigin: "166.47px 84.41px"
    },
    id: "elek0gifjzpqs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.11,67.58l.22.16Z",
    style: {
      fill: "none",
      transformOrigin: "171.22px 67.66px"
    },
    id: "eljb0jdv9z0a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.8,70.25c0,.1.06.19.08.29C172.86,70.44,172.83,70.35,172.8,70.25Z",
    style: {
      fill: "none",
      transformOrigin: "172.84px 70.395px"
    },
    id: "elcxl0aqls9ac",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173,71.05c0,.09,0,.17,0,.26C173,71.22,173,71.14,173,71.05Z",
    style: {
      fill: "none",
      transformOrigin: "173px 71.18px"
    },
    id: "elfenmpfhf9oa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.3,68.94c0,.09.1.16.14.25C172.4,69.1,172.35,69,172.3,68.94Z",
    style: {
      fill: "none",
      transformOrigin: "172.37px 69.065px"
    },
    id: "el7m12k2baoqc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.59,69.56c0,.09.07.17.1.27C172.66,69.73,172.62,69.65,172.59,69.56Z",
    style: {
      fill: "none",
      transformOrigin: "172.64px 69.695px"
    },
    id: "el7lbu0o10aki",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,68.41a1.84,1.84,0,0,1,.17.22A1.84,1.84,0,0,0,172,68.41Z",
    style: {
      fill: "none",
      transformOrigin: "172.085px 68.52px"
    },
    id: "elbj9uoixdjea",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.78,56.64l.43,0-.43,0Z",
    style: {
      fill: "none",
      transformOrigin: "172.995px 56.64px"
    },
    id: "els11wabamtl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.46,63.74l.17-.2h0Z",
    style: {
      fill: "none",
      transformOrigin: "159.545px 63.64px"
    },
    id: "elcfyhjwxxvkg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.77,82.33c-.16.18-.32.36-.49.53C168.45,82.69,168.61,82.51,168.77,82.33Z",
    style: {
      fill: "none",
      transformOrigin: "168.525px 82.595px"
    },
    id: "elwq0b7zwt10q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.1,56.64h0Z",
    style: {
      fill: "none",
      transformOrigin: "172.1px 56.64px"
    },
    id: "elhrj3dpytz8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.2,76.56l-.09.25Z",
    style: {
      fill: "none",
      transformOrigin: "172.155px 76.685px"
    },
    id: "eljyj6z5d09yl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.15,78.72h0l.15-.55h0Z",
    style: {
      fill: "none",
      transformOrigin: "151.225px 78.445px"
    },
    id: "el29kdru8sxxj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.27,62.89l.27-.27h0Z",
    style: {
      fill: "none",
      transformOrigin: "160.405px 62.755px"
    },
    id: "elg8haxs1ymec",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.71,80.58c0-.25.11-.5.17-.76h0C150.82,80.08,150.76,80.33,150.71,80.58Z",
    style: {
      fill: "none",
      transformOrigin: "150.795px 80.2px"
    },
    id: "el4antyzzgb6c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.1,85.94h0Z",
    style: {
      fill: "none",
      transformOrigin: "162.1px 85.94px"
    },
    id: "el0nb2y9vgbdgi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.25,80.42h0c.05-.07.1-.14.14-.21h0C170.35,80.28,170.3,80.35,170.25,80.42Z",
    style: {
      fill: "none",
      transformOrigin: "170.32px 80.315px"
    },
    id: "elm5tvx0cmob",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.86,79.45h0a.83.83,0,0,0,.07-.13h0A.83.83,0,0,1,170.86,79.45Z",
    style: {
      fill: "none",
      transformOrigin: "170.895px 79.385px"
    },
    id: "elc0bzwvvxpw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.89,85.68l.13,0h0Z",
    style: {
      fill: "none",
      transformOrigin: "160.955px 85.68px"
    },
    id: "elkw6h5ks5tz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.29,78.66l.12-.23-.12.23Z",
    style: {
      fill: "none",
      transformOrigin: "171.35px 78.545px"
    },
    id: "eledfegx5s2nb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.63,75.14h0c0-.13.07-.25.1-.38h0C172.7,74.89,172.67,75,172.63,75.14Z",
    style: {
      fill: "none",
      transformOrigin: "172.68px 74.95px"
    },
    id: "elt003amyx0ib",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173,73.23a9.73,9.73,0,0,0,.06-1.07q0,.41,0,.81Z",
    style: {
      fill: "none",
      transformOrigin: "173.03px 72.695px"
    },
    id: "el7egomazbla2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.74,77.72h0l0-.1h0Z",
    style: {
      fill: "none",
      transformOrigin: "171.74px 77.67px"
    },
    id: "elfm1g9mae48i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.81,74.35h0c0-.19.07-.39.1-.58h0C172.88,74,172.84,74.16,172.81,74.35Z",
    style: {
      fill: "none",
      transformOrigin: "172.86px 74.06px"
    },
    id: "elb3nb6xvil5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.4,76l.09-.3-.09.3Z",
    style: {
      fill: "none",
      transformOrigin: "172.445px 75.85px"
    },
    id: "elue6bdrqc6p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.68,81.23h0a2.83,2.83,0,0,0,.2-.28h0A2.83,2.83,0,0,1,169.68,81.23Z",
    style: {
      fill: "none",
      transformOrigin: "169.78px 81.09px"
    },
    id: "eljwcw54in4ql",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.29,85.85l.31-.07h0Z",
    style: {
      fill: "none",
      transformOrigin: "163.445px 85.815px"
    },
    id: "elvauzvg1qj59",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.68,85.93l.23,0h0Z",
    style: {
      fill: "none",
      transformOrigin: "162.795px 85.93px"
    },
    id: "el6nzihq0btln",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.43,85.85l.12,0h0Z",
    style: {
      fill: "none",
      transformOrigin: "161.49px 85.85px"
    },
    id: "el5u3fvdtay4h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.92,85.69a5.34,5.34,0,0,0,.52-.18h0Z",
    style: {
      fill: "none",
      transformOrigin: "164.18px 85.6px"
    },
    id: "el7hplonj06l3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.05,84l-.25.18c.25-.18.49-.38.73-.59l-.23.2Z",
    style: {
      fill: "none",
      transformOrigin: "167.165px 83.885px"
    },
    id: "el6oqxy5q53o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.81,85.37c.28-.13.56-.27.84-.43-.22.13-.45.24-.67.35Z",
    style: {
      fill: "none",
      transformOrigin: "165.23px 85.155px"
    },
    id: "elvju6vsu8zu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.05,82h0c.1-.11.2-.23.29-.35h0C169.25,81.78,169.15,81.9,169.05,82Z",
    style: {
      fill: "none",
      transformOrigin: "169.195px 81.825px"
    },
    id: "eljxbbrr9pdds",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.88,96.2l-.6.74,5.71,3.32L161.8,95.8A10.87,10.87,0,0,1,157.88,96.2Z",
    style: {
      fill: "current",
      transformOrigin: "160.135px 98.03px"
    },
    id: "elku16jf3d7xi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.53,63.36,185,62.14l-5.73-3.33-.39,1A10.77,10.77,0,0,1,180.53,63.36Z",
    style: {
      fill: "current",
      transformOrigin: "181.94px 61.085px"
    },
    id: "elvq53p0gpio",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173,71.05c0-.17,0-.35-.07-.51s0-.19-.08-.29-.07-.29-.11-.42-.07-.18-.1-.27-.09-.25-.15-.37-.09-.16-.14-.25l-.17-.31a1.84,1.84,0,0,0-.17-.22l-.2-.27-.2-.19a2.29,2.29,0,0,0-.23-.21l-.22-.16a4.58,4.58,0,0,0-4.51-.14,8.17,8.17,0,0,1,.07,1c0,.27,0,.54,0,.82l0,.26-.06.53c0,.19-.07.39-.1.59s0,.27-.08.4-.06.25-.1.38-.09.35-.14.53l-.09.3c-.06.2-.13.4-.2.6l-.09.24c-.1.27-.21.55-.33.82a.36.36,0,0,1,0,.09c-.1.24-.22.48-.34.72a2.26,2.26,0,0,1-.11.22q-.17.33-.36.66s0,.09-.07.14c-.15.25-.31.5-.47.75a1.64,1.64,0,0,1-.14.22l-.37.53-.2.28L163,78l-.29.36-.28.32c-.16.18-.33.35-.49.52l-.31.31-.25.24-.42.36-.25.21-.47.35-.22.16c-.23.16-.47.31-.71.45a7.17,7.17,0,0,1-.67.35l-.18.08-.15.06a4.73,4.73,0,0,0,2.12,3.73h0a2.86,2.86,0,0,0,.47.22l.11,0h0l.41.12.11,0h0a3.31,3.31,0,0,0,.55.07h.13a3.38,3.38,0,0,0,.45,0l.21,0h0l.38-.06.3-.06h0l.32-.09.52-.18h0l.37-.14.17-.08c.22-.11.45-.22.67-.35s.48-.29.71-.45l.22-.16.22-.17.25-.18.25-.21.23-.2.19-.17.25-.23.31-.31c.17-.17.33-.35.49-.53s.19-.21.28-.32h0c.1-.11.2-.23.29-.35h0c.12-.14.23-.28.34-.43h0a2.83,2.83,0,0,0,.2-.28h0c.13-.17.25-.35.37-.53h0c.05-.07.1-.14.14-.21h0c.16-.25.32-.5.47-.76h0a.83.83,0,0,0,.07-.13h0q.19-.33.36-.66h0l.12-.23c.11-.23.23-.47.33-.71h0l0-.1h0c.11-.27.22-.54.32-.81l.09-.25c.07-.19.14-.39.2-.59h0l.09-.3c0-.18.1-.36.14-.53h0c0-.13.07-.25.1-.38h0c0-.14.05-.27.08-.41h0c0-.19.07-.39.1-.58h0l.06-.54,0-.26q0-.41,0-.81a7.69,7.69,0,0,0,0-.85C173,71.22,173,71.14,173,71.05Z",
    style: {
      fill: "current",
      transformOrigin: "165.655px 76.4157px"
    },
    id: "elzdu7x25mqa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "181.21 53.85 174.85 50.16 171.02 47.98 177.38 51.67 181.21 53.85",
    style: {
      fill: "current",
      transformOrigin: "176.115px 50.915px"
    },
    id: "el2ezqyvpjzts",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.69 90.33 146.25 90.72 145.62 90.36 143.69 95.31 150.05 99 152.37 93.05 147.69 90.33",
    style: {
      fill: "current",
      transformOrigin: "148.03px 94.665px"
    },
    id: "elyjz4s1sdc6e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.62 53.9 173.38 56.67 177.38 51.67 171.02 47.98 167.62 52.22 168.27 52.59 168.62 53.9",
    style: {
      fill: "current",
      transformOrigin: "172.5px 52.325px"
    },
    id: "elulsorx7n6hq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.73,89.5l-3,.83,4.68,2.72A10.48,10.48,0,0,1,150.73,89.5Z",
    style: {
      fill: "current",
      transformOrigin: "150.07px 91.275px"
    },
    id: "el8o9qgv0i7tp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.46,57.06a11.58,11.58,0,0,1,2.64-.42h.68l.43,0h.17l-4.76-2.77Z",
    style: {
      fill: "current",
      transformOrigin: "171px 55.465px"
    },
    id: "el6e9ljlup4ue",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.88,79.82h0c.08-.36.17-.73.27-1.1h0l.15-.55h0c.29-1,.63-2,1-3L146,71.45c0,.09-.07.19-.11.28s-.11.31-.16.46-.2.54-.29.81c0,.06-.05.12-.07.17s-.07.27-.12.4c-.09.3-.19.6-.27.9a2.41,2.41,0,0,0-.08.25c0,.1-.05.2-.07.3q-.15.56-.27,1.11a3,3,0,0,0-.08.32c0,.15-.06.29-.09.43l6.36,3.7C150.76,80.33,150.82,80.08,150.88,79.82Z",
    style: {
      fill: "current",
      transformOrigin: "148.345px 76.015px"
    },
    id: "eluk5eh7i3nxa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.79,65.67c.54-.67,1.09-1.32,1.67-1.93l.17-.2h0l.64-.65.27-.27h0c.38-.37.77-.74,1.16-1.08l-6.36-3.7c-.39.35-.78.71-1.16,1.09l-.11.09-.52.54-.28.29c-.3.31-.59.64-.88,1l0,0c-.32.37-.63.74-.94,1.13h0Z",
    style: {
      fill: "current",
      transformOrigin: "156.575px 61.755px"
    },
    id: "eleq3msaj77nf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.71 80.58 144.35 76.88 139.88 80.82 146.24 84.52 150.71 80.58",
    style: {
      fill: "current",
      transformOrigin: "145.295px 80.7px"
    },
    id: "el6bjdpzq05on",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.24 84.52 139.88 80.82 139.89 87.03 145.62 90.36 146.25 90.72 146.24 84.52",
    style: {
      fill: "current",
      transformOrigin: "143.065px 85.77px"
    },
    id: "el3a3jw5g24vk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.87 55.71 156.51 52.02 155.34 57.84 161.7 61.54 162.87 55.71",
    style: {
      fill: "current",
      transformOrigin: "159.105px 56.78px"
    },
    id: "elpnnlfznvols",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.27 52.59 167.62 52.22 161.91 48.9 156.51 52.02 162.87 55.71 168.27 52.59",
    style: {
      fill: "current",
      transformOrigin: "162.39px 52.305px"
    },
    id: "eloctyp7ebtw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149.98 71.89 143.62 68.19 145.96 71.45 152.32 75.15 149.98 71.89",
    style: {
      fill: "current",
      transformOrigin: "147.97px 71.67px"
    },
    id: "elb3r9eixf5ks",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.79 65.67 151.43 61.97 151.43 61.97 147.42 61.6 153.78 65.3 157.79 65.67",
    style: {
      fill: "current",
      transformOrigin: "152.605px 63.635px"
    },
    id: "elqd74jeflxbp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elbcf84rmqg7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.88,96.2l-.6.74,5.71,3.32L161.8,95.8A10.87,10.87,0,0,1,157.88,96.2Z",
    style: {
      opacity: 0.2,
      transformOrigin: "160.135px 98.03px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eldxdi6itwmiv"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.53,63.36,185,62.14l-5.73-3.33-.39,1A10.77,10.77,0,0,1,180.53,63.36Z",
    style: {
      opacity: 0.2,
      transformOrigin: "181.94px 61.085px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elcz361k063y4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173,71.05c0-.17,0-.35-.07-.51s0-.19-.08-.29-.07-.29-.11-.42-.07-.18-.1-.27-.09-.25-.15-.37-.09-.16-.14-.25l-.17-.31a1.84,1.84,0,0,0-.17-.22l-.2-.27-.2-.19a2.29,2.29,0,0,0-.23-.21l-.22-.16a4.58,4.58,0,0,0-4.51-.14,8.17,8.17,0,0,1,.07,1c0,.27,0,.54,0,.82l0,.26-.06.53c0,.19-.07.39-.1.59s0,.27-.08.4-.06.25-.1.38-.09.35-.14.53l-.09.3c-.06.2-.13.4-.2.6l-.09.24c-.1.27-.21.55-.33.82a.36.36,0,0,1,0,.09c-.1.24-.22.48-.34.72a2.26,2.26,0,0,1-.11.22q-.17.33-.36.66s0,.09-.07.14c-.15.25-.31.5-.47.75a1.64,1.64,0,0,1-.14.22l-.37.53-.2.28L163,78l-.29.36-.28.32c-.16.18-.33.35-.49.52l-.31.31-.25.24-.42.36-.25.21-.47.35-.22.16c-.23.16-.47.31-.71.45a7.17,7.17,0,0,1-.67.35l-.18.08-.15.06a4.73,4.73,0,0,0,2.12,3.73h0a2.86,2.86,0,0,0,.47.22l.11,0h0l.41.12.11,0h0a3.31,3.31,0,0,0,.55.07h.13a3.38,3.38,0,0,0,.45,0l.21,0h0l.38-.06.3-.06h0l.32-.09.52-.18h0l.37-.14.17-.08c.22-.11.45-.22.67-.35s.48-.29.71-.45l.22-.16.22-.17.25-.18.25-.21.23-.2.19-.17.25-.23.31-.31c.17-.17.33-.35.49-.53s.19-.21.28-.32h0c.1-.11.2-.23.29-.35h0c.12-.14.23-.28.34-.43h0a2.83,2.83,0,0,0,.2-.28h0c.13-.17.25-.35.37-.53h0c.05-.07.1-.14.14-.21h0c.16-.25.32-.5.47-.76h0a.83.83,0,0,0,.07-.13h0q.19-.33.36-.66h0l.12-.23c.11-.23.23-.47.33-.71h0l0-.1h0c.11-.27.22-.54.32-.81l.09-.25c.07-.19.14-.39.2-.59h0l.09-.3c0-.18.1-.36.14-.53h0c0-.13.07-.25.1-.38h0c0-.14.05-.27.08-.41h0c0-.19.07-.39.1-.58h0l.06-.54,0-.26q0-.41,0-.81a7.69,7.69,0,0,0,0-.85C173,71.22,173,71.14,173,71.05Z",
    style: {
      opacity: 0.2,
      transformOrigin: "165.655px 76.4157px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el4q1gdklvbw8"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "147.69 90.33 146.25 90.72 145.62 90.36 143.69 95.31 150.05 99 152.37 93.05 147.69 90.33",
    style: {
      opacity: 0.2,
      transformOrigin: "148.03px 94.665px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eljn3m6j1n6zb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.73,89.5l-3,.83,4.68,2.72A10.48,10.48,0,0,1,150.73,89.5Z",
    style: {
      opacity: 0.2,
      transformOrigin: "150.07px 91.275px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elikylobikbtc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.46,57.06a11.58,11.58,0,0,1,2.64-.42h.68l.43,0h.17l-4.76-2.77Z",
    style: {
      opacity: 0.2,
      transformOrigin: "171px 55.465px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el4oj3drbkvy3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.88,79.82h0c.08-.36.17-.73.27-1.1h0l.15-.55h0c.29-1,.63-2,1-3L146,71.45c0,.09-.07.19-.11.28s-.11.31-.16.46-.2.54-.29.81c0,.06-.05.12-.07.17s-.07.27-.12.4c-.09.3-.19.6-.27.9a2.41,2.41,0,0,0-.08.25c0,.1-.05.2-.07.3q-.15.56-.27,1.11a3,3,0,0,0-.08.32c0,.15-.06.29-.09.43l6.36,3.7C150.76,80.33,150.82,80.08,150.88,79.82Z",
    style: {
      opacity: 0.2,
      transformOrigin: "148.345px 76.015px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elncfha6uwn4p"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "146.24 84.52 139.88 80.82 139.89 87.03 145.62 90.36 146.25 90.72 146.24 84.52",
    style: {
      opacity: 0.2,
      transformOrigin: "143.065px 85.77px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ele6zkax5k0g"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "162.87 55.71 156.51 52.02 155.34 57.84 161.7 61.54 162.87 55.71",
    style: {
      opacity: 0.2,
      transformOrigin: "159.105px 56.78px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elcto8czqoas"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "149.98 71.89 143.62 68.19 145.96 71.45 152.32 75.15 149.98 71.89",
    style: {
      opacity: 0.2,
      transformOrigin: "147.97px 71.67px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elolf05helpb9"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "157.79 65.67 151.43 61.97 151.43 61.97 147.42 61.6 153.78 65.3 157.79 65.67",
    style: {
      opacity: 0.2,
      transformOrigin: "152.605px 63.635px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "153.78 65.3 147.42 61.6 143.62 68.19 149.98 71.89 153.78 65.3",
    style: {
      fill: "current",
      transformOrigin: "148.7px 66.745px"
    },
    id: "elywpodu3188a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "els4js72ocpsd"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "168.62 53.9 173.38 56.67 177.38 51.67 171.02 47.98 167.62 52.22 168.27 52.59 168.62 53.9",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "172.5px 52.325px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el3eb2m0uq21i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.79,65.67c.54-.67,1.09-1.32,1.67-1.93l.17-.2h0l.64-.65.27-.27h0c.38-.37.77-.74,1.16-1.08l-6.36-3.7c-.39.35-.78.71-1.16,1.09l-.11.09-.52.54-.28.29c-.3.31-.59.64-.88,1l0,0c-.32.37-.63.74-.94,1.13h0Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "156.575px 61.755px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elv4q9t9kvmlg"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "150.71 80.58 144.35 76.88 139.88 80.82 146.24 84.52 150.71 80.58",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "145.295px 80.7px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elt770db5p0w"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "168.27 52.59 167.62 52.22 161.91 48.9 156.51 52.02 162.87 55.71 168.27 52.59",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "162.39px 52.305px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eluhfnb4qo7en"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "153.78 65.3 147.42 61.6 143.62 68.19 149.98 71.89 153.78 65.3",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "148.7px 66.745px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M180.55,72.28,185,68.34v-6.2l-4.48,1.22a10.77,10.77,0,0,0-1.64-3.55l.39-1,1.93-5-3.83-2.19-4,5h-.17l-.43,0h-.68a11.58,11.58,0,0,0-2.64.42l-.84-3.16-.35-1.3-5.4,3.11-1.17,5.83c-.39.34-.78.71-1.16,1.08l-.27.27-.64.65-.17.2c-.58.61-1.13,1.26-1.67,1.93l-4-.37L150,71.89l2.34,3.26c-.39,1-.73,2-1,3l-.15.55c-.1.37-.19.74-.27,1.1s-.12.51-.17.76l-4.47,3.94v6.2l1.44-.39,3-.83a10.48,10.48,0,0,0,1.64,3.55l-2.32,6,3.83,2.18,3.4-4.24.6-.74a10.87,10.87,0,0,0,3.92-.4l1.19,4.46,5.4-3.11,1.17-5.83a31.23,31.23,0,0,0,3.9-4.12l4,.36,3.8-6.59-2.34-3.25A33,33,0,0,0,180.55,72.28Zm-7.58,1-.06.54c0,.19-.07.39-.1.58s-.05.27-.08.41-.06.25-.1.38-.09.35-.14.53l-.09.3c-.06.2-.13.4-.2.59l-.09.25c-.1.27-.21.54-.32.81l0,.1c-.1.24-.22.48-.33.71l-.12.23q-.16.33-.36.66a.83.83,0,0,1-.07.13c-.15.26-.31.51-.47.76,0,.07-.09.14-.14.21s-.24.36-.37.53a2.83,2.83,0,0,1-.2.28c-.11.15-.22.29-.34.43s-.19.24-.29.35-.18.22-.28.32-.32.36-.49.53l-.31.31-.25.23-.19.17c-.24.21-.48.41-.73.59l-.22.17-.22.16c-.23.16-.47.31-.71.45s-.56.3-.84.43l-.37.14a5.34,5.34,0,0,1-.52.18l-.32.09-.31.07-.38.06-.23,0a3.38,3.38,0,0,1-.45,0h-.13a3.31,3.31,0,0,1-.55-.07l-.12,0-.41-.12-.13,0a2.86,2.86,0,0,1-.47-.22h0a4.73,4.73,0,0,1-2.12-3.73,8.52,8.52,0,0,1-.06-1,16.22,16.22,0,0,1,7.38-12.77,7,7,0,0,1,1-.49,4.58,4.58,0,0,1,4.51.14l.22.16a2.29,2.29,0,0,1,.23.21l.2.19.2.27a1.84,1.84,0,0,1,.17.22l.17.31c0,.09.1.16.14.25s.1.25.15.37.07.17.1.27.08.28.11.42.06.19.08.29.05.34.07.51,0,.17,0,.26a7.69,7.69,0,0,1,0,.85A9.73,9.73,0,0,1,173,73.23Z",
    style: {
      fill: "current",
      transformOrigin: "165.64px 76.415px"
    },
    id: "elpqoqhnajxjm",
    className: "animable"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSomethingWrong);
export default __webpack_public_path__ + "static/media/something-wrong.b44733eb829079b6b2c693310595be43.svg";
export { ForwardRef as ReactComponent };